/*
 * @Author: w
 * @Date: 2022-03-31 18:09:27
 * @LastEditors: xuqiang@mingxinsk.com
 * @LastEditTime: 2023-12-06 15:15:08
 */
import Abstract from '../abstract'
import {
  AddCompany,
  EditCompany,
  CityParams,
  DeletePersonAndCompany,
  EmployeeParams,
  AuditNewBloodEmployee,
  organizationRoleChangeAndCompany,
  organizationPersonId
} from '../types'
class Request extends Abstract {
  //刷新token
  refreshToken(data: any) {
    return this.post({ url: 'saas/open/user/refreshToken', data })
  }

  // 获取当前企业
  getCurrentCompany() {
    return this.get({ url: 'saas/organization/current' })
  }
  // 获取无组织企业用户的可用菜单
  getMenuByAll() {
    return this.get({ url: 'saas/get_all_app_for_person' })
  }
  // 刷新token
  getRefreshToken(data: any) {
    return this.post({ url: 'saas/open/user/refreshToken', data, headers: { Authorization: null } })
  }
  // 获取模块
  getOrgPerson() {
    return this.get({ url: 'saas/user/app/lease' })
  }
  addEnterprise(data: AddCompany) {
    return this.post({ url: 'saas/organization/save', data })
  }
  editEnterprise(data: EditCompany) {
    return this.post({ url: 'saas/organization/edit', data })
  }
  // 退税助手发送消息
  sendAiQuestion (data:any) {
    return this.post({ url: '/saas/aigc/mh_innner_api/send/question', data })
  }
  // 问答聊天记录
  getAnswerList(data: any) {
    return this.post({ url: '/saas/aigc/mh_innner_api/query/answer/list', data })
  }
  // 问答提示记录
  getTipsAnswerList(params: any) {
    return this.get({ url: '/saas/aigc/mh_innner_api/query/steer/questionByGroup', params })
  }
  // 个人信息
  getUserMessage() {
    return this.get({ url: 'saas/user/get' })
  }

  // 微信注册账号修改用户名
  updateUserName(data: object) {
    return this.post({ url: 'saas/user/update/userName', data })
  }
  // 修改姓名
  updateName(data: object) {
    return this.post({ url: 'saas/user/update/name', data })
  }
  /** 发送短信获取验证码 */
  sendPhoneText(params: object | undefined) {
    return this.get({ url: 'saas/sms/send', params })
  }
  /** 发送邮箱获取验证码 */
  sendEmailText(email: string, params: object) {
    return this.get({ url: `saas/common/send/mail/${email}`, params })
  }
  /** 绑定手机 */
  setPhone(data: object) {
    return this.post({ url: 'saas/user/bindPhone', data })
  }
  /** 绑定邮箱 */
  setEmil(data: object) {
    return this.post({ url: 'saas/user/bindEmail', data })
  }
  /** 微信绑定账号 */
  setExistAccount(data: object) {
    return this.post({ url: 'saas/user/weChat/bind', data })
  }
  // 个人角色
  getUserRole() {
    return this.get({ url: 'saas/user/roles' })
  }
  // 申请加入
  joinEnterprise(id: number) {
    return this.post({ url: `saas/organization/apply/${id}` })
  }
  // 获得可管理企业列表
  getEnterpriseList(data: any) {
    return this.post({ url: `saas/organization/page`, data })
  }
  //根据企业平台类型获取企业
  getEnterpriseByplatform(page: any, data: any) {
    return this.post({ url: `/saas/organization/query/platform/info/${page}`, data })
  }
  //获得fap可管理企业列表
  postFapEnterpriseList(data: any) {
    return this.post({ url: `/bi/organization/page`, data })
  }
  //查询用户汇总对应的企业列表
  postRelationCompanyList(data:any){
    return this.post({url:`/saas/user/organization`,data})
  }
  //获得fap可管理企业列表-item-是否跳过验证
  getFapEnterpriseItemCheck(id: number) {
    return this.get({ url: `/bi/organization/check/${id}` })
  }
  //获得企业-是否跳过验证 头部右上角
  getEnterpriseCheck() {
    return this.get({ url: `/saas/organization/check` })
  }
  //企业数据汇总-业务信息-采购订单
  postOriganizationPurchase(data: any) {
    return this.post({ url: `/bi/organization/purchase/order/page`, data })
  }
  //企业数据汇总-业务信息-销售订单
  postOriganizationSales(data: any) {
    return this.post({ url: `/bi/organization/sales/order/page`, data })
  }
  //企业数据汇总-业务信息-订仓单
  postOriganizationBook(data: any) {
    return this.post({ url: `/bi/organization/booking/order/query/order/list`, data })
  }
  //企业数据汇总-业务信息-报关单
  postOriganizationDecalaration(data: any) {
    return this.post({ url: `/bi/organization/declaration/page`, data })
  }
  //导出报关单
  postExportBiDecalare(data:any, responseType: any){
    return this.post({url:`/bi/declaration/exportPageList`,data,responseType})
  }
  //企业数据汇总-业务信息-出口委托单
  postOriganizationExportDecalaration(data: any) {
    return this.post({ url: `/bi/organization/exp/dec/customs/export/declaration/page`, data })
  }
  //企业数据汇总-业务信息-提运单
  postOriganizationLadingBill(data: any) {
    return this.post({ url: `/bi/organization/lading/bill/page`, data })
  }
  //企业数据汇总-业务信息-委托报关协议
  postOriganizationDecAgreement(data: any) {
    return this.post({ url: `/bi/organization/dec/agreement/page`, data })
  }
  //企业数据汇总-业务信息-退税数据
  postOriganizationTaxRefundRecord(data: any) {
    return this.post({ url: `/bi/organization/tax/refund/record/page`, data })
  }
  //企业数据汇总-业务信息-退税数据-退税数据统计
  postOriganizationTaxRefundRecordStat(data: any) {
    return this.post({ url: `/bi/organization/tax/refund/record/stat`, data })
  }
  //企业数据汇总-业务信息-采购订单-详情
  getOriganizationPurchaseDetail(id: any) {
    return this.get({ url: `/bi/organization/purchase/order/details/${id}` })
  }
  //企业数据汇总-业务信息-销售订单-详情
  getOriganizationSalesDetail(id: any) {
    return this.get({ url: `/bi/organization/sales/order/details/${id}` })
  }
  //企业数据汇总-业务信息-订仓单-详情
  getOriganizationBookingDetail(id: any) {
    return this.get({ url: `/bi/organization/booking/order/details/${id}` })
  }


  //--------------------------fap智能客服/知识库管理模块------------------------------------
  //新增知识库
  postAddKnowlegebase(data:any){
    return this.post({url:`/saas/knowledgebase/add`,data})
  }
  //获取知识库列表
  getKnowlegeBaseList(){
    return this.get({url:`/saas/knowledgebase/list`})
  }
  //下载知识库模板
  getDownloadFile(){
    return this.get({url:`/saas/knowledgebase/template`})
  }
  //导入文件
  postKnowlegeBaseFile(data:any,id:string){
    return this.post({url:`/saas/knowledgebase/import?id=${id}`,data})
  }
  //获取文件集合
  getFileList(params:any){
    return this.get({url:'/saas/knowledgebase/fileList',params})
  }
  //获取问答列表
  getQAList(data:any){
    return this.post({url:'/saas/knowledgebase/qaPage',data})
  }
  //编辑问答列表
  postUpdateQA(data:any){
    return this.post({url:'/saas/knowledgebase/update/qa',data})
  }


  // //企业数据汇总-业务信息-报关单-详情9610
  // getOriganizationDecalarationDetail9610(id: any) {
  //   return this.get({ url: `/bi/organization/declaration/get9610/${id}` })
  // }
  // //企业数据汇总-业务信息-报关单-详情0110-9710-9810
  // getOriganizationDecalarationDetail(id: any) {
  //   return this.get({ url: `/bi/organization/declaration/get0110/or/9710/${id}` })
  // }
  // //企业数据汇总-业务信息-出口委托单-详情
  // getOriganizationExportDecalarationDetail(id: any) {
  //   return this.get({ url: `/bi/organization/exp/dec/customs/details/${id}` })
  // }
  // //企业数据汇总-业务信息-提运单-详情
  // getOriganizationLadingBillDetail(id: any) {
  //   return this.get({ url: `/bi/organization/lading/bill/info/${id}` })
  // }
  // //企业数据汇总-业务信息-委托报关协议-详情
  // getOriganizationDecAgreementDetail(id: any) {
  //   return this.get({ url: `/bi/organization/dec/agreement/info/${id}` })
  // }
  //获取注册渠道商
  getChannel() {
    return this.get({ url: `/bi/organization/channel` })
  }
  // 获取所属企业列表
  getBelongEnterpriseList(page: any, data: any) {
    return this.post({ url: `saas/organization/manage/list/${page}`, data })
  }
  //获取企业下的用户
  getRelationUserList(data:any){
    return this.post({ url: `saas/organization/query/user`, data })
  }
  // 获得企业详情
  getEnterpriseDetail(id: number) {
    return this.get({ url: `saas/organization/find/${id}` })
  }
  // 获得Fap企业详情
  getfAPEnterpriseDetail(id: number) {
    return this.get({ url: `/bi/organization/details/${id}` })
  }
  // 切换公司
  toggleCompany(id: number, keycloakRefreshToken: string) {
    return this.post({ url: `saas/organization/toggle/${id}/${keycloakRefreshToken}` })
  }
  // 获取城市列表
  getCityList(data: CityParams) {
    return this.post({ url: `saas/tax/city/all`, data })
  }
  // 退出企业
  quitCompany(id: number) {
    return this.delete({ url: `saas/organization/quit/${id}` })
  }
  // 申请记录
  getApplyList(data: any) {
    return this.post({ url: `saas/organization/apply/page`, data })
  }
  getRole() {
    return this.get({ url: `saas/common/get/role` })
  }
  //获取DXPID类型
  getDXPIDType(){
    return this.get({ url: `saas/common/electronic/port/dxp` })
  }
  /* 登录注册模块 */
  //获取手机验证码
  getValidCode() {
    return this.get({ url: `saas/user/init/login/phone/code`, headers: { Authorization: null } })
  }
  //微信登录
  postWechatLogin(data: any) {
    return this.post({ url: `/wechat-mp/wx/user/login`, data, headers: { Authorization: null } })
  }
  //微信绑定
  postWechatBind(data: any) {
    return this.post({ url: `/wechat-mp/wx/user/bind`, data })
  }
  getWechatCode() {
    return this.get({ url: `/wechat-mp/mp-qr`, headers: { Authorization: null } })
  }
  getWechatScan(ticketString: string) {
    return this.get({ url: `/wechat-mp/mp-qr-scan-status?ticket=${ticketString}`, headers: { Authorization: null } })
  }
  //手机号登录
  postPhoneLogin(data: any) {
    return this.post({ url: `saas/user/init/login/phone`, data, headers: { Authorization: null } })
  }
  //获取重置密码验证码
  getResetCode(params: any) {
    return this.get({ url: `saas/user/init/retrieve/code`, params, headers: { Authorization: null } })
  }
  //提交重置密码
  postResetPassword(data: any) {
    return this.post({ url: `saas/user/init/retrieve`, data, headers: { Authorization: null } })
  }
  //账户密码登录
  postUserCountLogin(data: any) {
    return this.post({ url: `saas/user/init/login`, data, headers: { Authorization: null } })
  }
  // 获取验证码前验证图片
  getCapCha () {
    return this.get({ url: `saas/user/init/get/captcha`, headers: { Authorization: null } })
  }
  //获取注册验证码
  getRegisterValidCode(data: any) {
    return this.post({ url: `saas/user/init/register/phone/code`, data, headers: { Authorization: null } })
  }
  //获取手机号登录验证码
  getPhoneLoginCode(params: any) {
    return this.get({ url: `saas/user/init/login/phone/code`, params, headers: { Authorization: null } })
  }
  //注册
  postRegister(data: any) {
    return this.post({ url: `saas/user/init/register`, data, headers: { Authorization: null } })
  }
  //退出登录
  postLoginOut(){
    return this.post({url:`saas/user/init/logout`})
  }
  // 邮储注册
  postPsbcRegister(data: any) {
    return this.post({ url: `saas/user/init/psbc/register`, data, headers: { Authorization: null } })
  }
  // 可管理企业员工列表
  getEmployeeList(data: EmployeeParams) {
    return this.post({ url: `saas/organization/staff/list`, data })
  }
  //获取超级管理员信息
  getAdminInfo() {
    return this.get({ url: `saas/organization/find/admin` })
  }
  //获取fap用户数据汇总列表
  getUserList(data: any) {
    return this.post({ url: `/bi/user/pageList`, data })
  }
  //修改用户信息
  postUpdateUser(data:any){
    return this.post({ url: `saas/user/update`, data })
  }
  // 便携企业切换
  getToggleSwitch(id: any) {
    return this.get({ url: `/bi/user/toggleSwitch/${id}` })
  }
  // 删除员工
  deleteEmployee(data: DeletePersonAndCompany) {
    return this.delete({ url: `saas/organization/delete/person/${data.personId}/${data.companyId}` })
  }
  // 审核申请
  auditNewBloodEmployee(data: AuditNewBloodEmployee) {
    return this.put({ url: `saas/organization/audit/${data.personId}/${data.companyId}/${data.passId}` })
  }
  // 撤销申请
  applyCancel(id: number) {
    return this.put({ url: `saas/organization/revoke/${id}` })
  }
  // 重新申请
  applyAgain(id: number) {
    return this.put({ url: `saas/organization/new/apply//${id}` })
  }
  //角色列表
  organizationRole(data: DeletePersonAndCompany) {
    return this.get({ url: `saas/organization/staff/role/${data.personId}/${data.companyId}` })
  }
  // 用户权限更新1
  organizationRoleChange(data: organizationRoleChangeAndCompany) {
    return this.put({ url: `saas/organization/edit/role/${data.personId}/${data.companyId}/${data.role}` })
  }
  //超级管理员角色转移
  organizationRoleTransfer(data: organizationPersonId) {
    return this.put({ url: `saas/organization/transfer/role/${data.personId}` })
  }
  //  企业申请认证
  getCertification() {
    return this.get({ url: 'saas/organization/certification' })
  }
  //实名后修改企业名称
  getNewOrganizationName(id: Number) {
    return this.put({ url: `saas/organization/sync/edit/${id}` })
  }
  // 取消认证
  getCancelCertification() {
    return this.get({ url: 'saas/organization/cancel/certification' })
  }
  // 邮箱发送
  sentEmail(email: string) {
    return this.get({ url: `saas/common/send/mail/${email}` })
  }
  // 修改邮箱
  changeEmail(email: string, code: string) {
    return this.put({ url: `saas/organization/edit/email/${email}/${code}` })
  }
  // 增值税企业类型代码
  getCommonVat() {
    return this.get({ url: 'saas/common/vat' })
  }
  // 出口退税企业类型代码
  getCommonExport() {
    return this.get({ url: 'saas/common/export' })
  }
  //用户认证 user/get
  getUserSure() {
    return this.get({ url: 'saas/user/authenticate' })
  }
  // 银行管理列表
  getBankPageList(data: any) {
    return this.post({ url: 'saas/bank/page', data })
  }
  // 新增银行信息
  saveBank(data: any) {
    return this.post({ url: 'saas/bank/save', data })
  }
  // 编辑银行信息
  updateBank(data: any) {
    return this.post({ url: 'saas/bank/update', data })
  }
  // 删除银行信息
  deleteBank(params: any) {
    return this.get({ url: 'saas/bank/delete', params })
  }
  // 供应商列表
  getVendorPageList(data: any) {
    return this.post({ url: 'saas/vendor/page', data })
  }
  // 新增供应商
  saveVendor(data: any) {
    return this.post({ url: 'saas/vendor/save', data })
  }
  // 编辑供应商
  updateVendor(data: any) {
    return this.post({ url: 'saas/vendor/update', data })
  }
  // 删除供应商
  deleteVendor(params: any) {
    return this.get({ url: 'saas/vendor/delete', params })
  }
  /*---------------协议管理---------------------*/
  // 获取协议签署结果
  agreementResult() {
    return this.get({ url: 'agreement/open/sign/result' })
  }
  // 催签/重新发送
  agreementRushSign() {
    return this.get({ url: 'agreement/open/signers/rushsign' })
  }
  /*
    数据授权协议： data
    出口代理协议/代理报关服务协议:   export
    金融服务协议:   loan
    出口代理协议/物流服务协议:   logistics
  */
  // 菜单栏及子菜单栏
  agreementMenu(agreementType: string) {
    return this.get({ url: `/agreement/${agreementType}/menus` })
  }
  //新增协议 ==四个协议
  agreementSave(agreementType: string, data: any) {
    return this.post({ url: `agreement/${agreementType}/state/machine/send_event_local`, data })
  }
  // //审核状态
  // agreementAudit(){
  //   return this.get({ url:'/agreement/audit' });
  // }
  // //协议状态
  // agreementStatus(){
  //   return this.get({ url:'/agreement/status' });
  // }
  //四个==申请类型
  agreementApplyStatus() {
    return this.get({ url: 'agreement/common/agreement/apply/type' })
  }
  // 申请列表
  agreementApplyList(agreementType: string, page: number, data: any) {
    return this.post({ url: `agreement/${agreementType}/search/apply/${page}`, data })
  }
  // 审核列表
  agreementAuditList(agreementType: string, page: number, data: any) {
    return this.post({ url: `agreement/${agreementType}/search/audit/${page}`, data })
  }
  // 协议列表 电商
  agreementList(agreementType: string, page: number, data: any) {
    return this.post({ url: `agreement/${agreementType}/search/${page}`, data })
  }
  //委托单协议列表
  getServiceOrderAgreementList(page: number, data: any) {
    return this.post({ url: `/agreement/server/order/${page}`, data })
  }
  //协议变更记录
  agreementChangeLog(agreementType: string, agreementId: string) {
    return this.get({ url: `/agreement/change/log/${agreementType}/${agreementId}` })
  }
  //协议详情 电商
  agreementDetail(agreementType: string, agreementId: string) {
    return this.get({ url: `agreement/${agreementType}/details/${agreementId}` })
  }
  //审核/撤销/协议变更-变更/解除协议/延期协议  通过"events":["APPROVED"],拒绝"events":["REJECTS"],
  agreementEventOperation(agreementType: string, data: any) {
    return this.post({ url: `agreement/${agreementType}/state/machine/send_event_local`, data })
  }
  //20230303
  //入驻列表
  agreementListNew(data: any) {
    return this.post({ url: `agreement/settlement/search`, data })
  }
  //入驻状态
  getAgreementStatusNew() {
    return this.get({ url: 'agreement/settlement/status' })
  }
  //入驻详情
  agreementDetailNew(agreementId: string) {
    return this.get({ url: `agreement/settlement/details/${agreementId}` })
  }
  //入驻 所有事件
  getAgreementEventNew() {
    return this.get({ url: `agreement/settlement/event` })
  }
  //入驻内容
  getAgreementContenttNew(type: string) {
    return this.get({ url: `agreement/settlement/agreement/content/${type}` })
  }
  //入驻 获取当前状态机的事件
  getStateAgreementNew(params: any) {
    return this.get({ url: `agreement/settlement/get_state`, params })
  }
  //入驻 获取当前状态机的事件 卖方
  getStateAgreementEcepl(params: any) {
    return this.get({ url: `agreement/ecepl/state/machine/get_state`, params })
  }
  //入驻 审核/撤销/协议变更-变更/解除协议/延期协议  通过"events":["APPROVED"],拒绝"events":["REJECTS"],
  agreementEventOperationNew(data: any) {
    return this.post({ url: `agreement/settlement/send_event_local`, data })
  }
  //入驻 获取文件下载访问地址
  getAgreementDownload(id: string) {
    return this.get({ url: `agreement/settlement/get/download/url/${id}` })
  }
  //卖方入驻-添加收费模式
  getAgreementChargeModel() {
    return this.get({ url: `agreement/common/chargeModel` })
  }
  //卖方入驻-添加服务类目
  getAgreementServiceCategory() {
    return this.get({ url: `agreement/common/serviceCategory` })
  }

  //审核服务列表
  agreementServeAuditListNew(page: number, data: any) {
    return this.post({ url: `agreement/server/audit/${page}`, data })
  }
  //服务列表
  agreementServeListNew(data: any) {
    return this.post({ url: `agreement/server/search`, data })
  }
  //服务状态
  getAgreementServeStatusNew() {
    return this.get({ url: 'agreement/server/status' })
  }
  //服务详情
  agreementServeDetailNew(agreementId: string) {
    return this.get({ url: `agreement/server/details/${agreementId}` })
  }
  //服务事件
  getAgreementServeEventNew() {
    return this.get({ url: `agreement/server/event` })
  }
  //服务内容
  getAgreementServeContenttNew(type: string) {
    return this.get({ url: `agreement/server/agreement/content/${type}` })
  }
  //服务 获取当前状态机的事件
  getStateAgreementServeNew(params: any) {
    return this.get({ url: `agreement/server/get_state`, params })
  }
  //服务 审核/撤销/协议变更-变更/解除协议/延期协议  通过"events":["APPROVED"],拒绝"events":["REJECTS"],
  agreementServeEventOperationNew(data: any) {
    return this.post({ url: `agreement/server/send_event_local`, data })
  }
  //服务 获取文件下载访问地址
  getAgreementServeDownload(id: string) {
    return this.get({ url: `agreement/server/get/download/url/${id}` })
  }

  //根据企业平台类型分页查询
  getPlatform(page: String, data: any) {
    return this.post({ url: `/saas/organization/query/platform/info/${page}`, data })
  }
  //20230824-企业关系管理-协议列表
  getAgreementList() {
    return this.get({ url: `agreement/template/applyList` })
  }
  //20230824-企业关系管理-协议审批列表
  getAgreementAuditList() {
    return this.get({ url: `agreement/template/auditList` })
  }
  // 发起入驻协议时 甲方的查询接口
  getPlatformInfo() {
    return this.get({ url: `saas/organization/platform/info` })
  }

  /*
  新增三个协议：
  * cblep： 跨境物流企业平台入驻协议
  * cbpl：报关行平台入驻协议
  * ecepl：电商企业平台入驻协议
  */

  //入驻协议- - 协议内容
  //获取协议类型
  getAgreementType() {
    return this.get({ url: `agreement/common/agreement/domain/type` })
  }
  //获取协议内容
  getAgreementContent(type: string) {
    return this.get({ url: `agreement/common/agreement/content/new/${type}` })
  }
  getArticle() {
    return this.get({ url: `agreement/ecepl/article` })
  }
  getArticleCblep() {
    return this.get({ url: `agreement/cblep/article` })
  }
  getArticleCbpl() {
    return this.get({ url: `agreement/cbpl/article` })
  }
  //-------------电商入驻协议相关接口---------
  //获取电商入驻协议状态
  geteceplStatus() {
    return this.get({ url: 'agreement/ecepl/status' })
  }
  //获取电商入驻协议列表
  geteceplList(page: number, data: any) {
    return this.post({ url: `agreement/ecepl/review/${page}`, data })
  }
  //获取电商入驻协议详情
  geteceplDetail(id: string) {
    return this.get({ url: `agreement/ecepl/details/${id}` })
  }
  //获取电商入驻协议事件
  geteceplEvent() {
    return this.get({ url: `agreement/ecepl/event` })
  }
  //提交审核电商入驻协议
  posteceplAudit(data: any) {
    return this.post({ url: `agreement/ecepl/state/machine/send_event_local`, data })
  }
  // 其他协议 协议内容
  agreementArticleData() {
    return this.get({ url: `agreement/data/article` })
  }
  agreementArticleExport() {
    return this.get({ url: `agreement/export/article` })
  }
  agreementArticleLoan() {
    return this.get({ url: `agreement/loan/article` })
  }
  agreementArticleLogistics() {
    return this.get({ url: `agreement/logistics/article` })
  }
  // 新- - 协议状态
  getNewApplyStatus(agreementType: string, data: any) {
    return this.get({ url: `agreement/${agreementType}/status`, data })
  }
  // 新- - 申请类型
  getNewApplyType() {
    return this.get({ url: 'agreement/apply/agreementType' })
  }
  // 新- - 协议详情
  getNewDetail(agreementType: string, id: string) {
    return this.get({ url: `agreement/${agreementType}/details/${id}` })
  }
  // 跨境物流企业平台入驻协议- - 事件
  getCblepEvent() {
    return this.get({ url: 'agreement/cblep/event' })
  }
  // data/get/download/url/1
  getDownload(agreementType: string, id: string) {
    return this.get({ url: `agreement/${agreementType}/get/download/url/${id}` })
  }
  /*======= end ===========*/
  /*===================订单管理start======================*/
  // 初始化订单编号
  getOrderNum() {
    return this.get({ url: '/service-order/exp/dec/common/init/number' })
  }
  // 运输方式
  getOrderTransport() {
    return this.get({ url: '/service-order/exp/dec/common/transport/mode' })
  }
  // 成交方式
  getOrderDealMethod() {
    return this.get({ url: '/service-order/exp/dec/common/deal/method' })
  }
  // 离境口岸
  getOrderDomesticport() {
    return this.get({ url: '/service-order/exp/dec/common/domestic/port' })
  }
  // 出境海关
  getOrderCustomsArea() {
    return this.get({ url: '/service-order/exp/dec/common/customs/area' })
  }
  // 国家
  getOrderCountry() {
    return this.get({ url: '/service-order/exp/dec/common/country' })
  }
  //境内货源地
  getOriginPlace(params: any) {
    return this.get({ url: '/service-order/exp/dec/customs/query/goods/origin/place/', params })
  }
  // 指运港
  getOrderPort() {
    return this.get({ url: '/service-order/exp/dec/common/port' })
  }
  // 监管方式
  getOrderRegulatory() {
    return this.get({ url: '/service-order/exp/dec/common/regulatory/approach' })
  }
  //GET集装规格
  getOrderSpecification() {
    return this.get({ url: '/service-order/exp/dec/common/container/specification' })
  }
  //转关类型
  getTransitType() {
    return this.get({ url: '/service-order/exp/dec/common/transitType' })
  }
  //税单类型
  getTaxOrderType() {
    return this.get({ url: '/service-order/exp/dec/common/taxOrderType' })
  }
  //转关申报单类型
  getCustomsTransitDeclarationType() {
    return this.get({ url: '/service-order/exp/dec/common/customsTransitDeclarationType' })
  }
  //征免性质
  getTaxationMethod() {
    return this.get({ url: '/service-order/exp/dec/common/taxationMethod' })
  }
  //征免方式
  getTaxationWay(){
    return this.get({ url: '/service-order/exp/dec/common/dutyMode' })
  }
  //随附单据类型
  getFileType(params: any) {
    return this.get({ url: '/service-order/exp/dec/common/dec_att_type_code_v', params })
  }
  //获取进口委托单状态
  getImportOrderState() {
    return this.get({ url: '/service-order/inlet/order/state' })
  }
  //进口委托单列表
  postInletOrderList(data: any) {
    return this.post({ url: '/service-order/inlet/order/page', data })
  }
  //暂存进口委托单
  postSubmitOrder(data: any) {
    return this.post({ url: '/service-order/inlet/order/send_event_local', data })
  }

  //获取进口委托单详情
  getImportOrderDetail(id: String) {
    return this.get({ url: `/service-order/inlet/order/details/${id}` })
  }

  //获取9610委托单状态
  get9610OrderState() {
    return this.get({ url: '/service-order/state/machine/order9610/state' })
  }
  //获取9610委托单事件
  get9610OrderEvent() {
    return this.get({ url: '/service-order/state/machine/order9610/event' })
  }
  // 状态
  getOrderState() {
    return this.get({ url: '/service-order/exp/dec/common/state' })
  }

  // 事件
  getOrderEvent() {
    return this.get({ url: '/service-order/exp/dec/common/event' })
  }
  // 文件上传
  getOrderUpload(data: any) {
    return this.post({ url: '/service-order/exp/dec/common/upload', data })
  }
  //获取文件下载预览地址
  getOrderFileAddress(data: any) {
    return this.post({ url: `/service-order/exp/dec/common/file/address`, data })
    // headers:{'Content-Type': 'application/x-www-form-urlencoded'}}
  }
  //获取文件下载预览地址
  getAgreementFileAddress(data: any) {
    return this.post({ url: `/agreement/common/file/address`, data })
  }
  // 订单的事件---->提交新增/取消/更新
  getOrderSendEvent(data: any) {
    return this.post({ url: '/service-order/exp/dec/state/machine/send_event_local', data })
  }
  // 订单的事件---->撤销
  getOrderCancelSendEvent(data: any, token?: string, reftoken?: string) {
    return this.post({ url: '/service-order/exp/dec/state/machine/send_event_local', data, headers: { token, reftoken } })
  }
  //9610事件状态机
  get9610OrderSendEvent(data: any) {
    return this.post({ url: '/service-order/state/machine/order9610/send_event_local', data })
  }
  // 单位类型
  getOrdercommonUnit() {
    return this.get({ url: '/service-order/exp/dec/common/unit/type' })
  }
  // 单位类型：根据类型不一样：单位/金额/币制
  getOrdercommonUnitEach(type: string) {
    return this.get({ url: `/service-order/exp/dec/common/unit/${type}` })
  }
  //获取包装类型
  getWrapTypeList() {
    return this.get({ url: `/service-order/exp/dec/common/packing` })
  }
  // 出口报关列表 exp/dec/customs/export/declaration/page/1
  getDeclarationList( data: any) {
    return this.post({ url: `/service-order/exp/dec/customs/export/declaration/page`, data })
  }
  //获取fap订单列表
  getBiOrderList(data: any) {
    return this.post({ url: `/bi/order/page`, data })
  }
  //获取fap订单详情
  getFapOrderDetail(id: any) {
    return this.get({ url: `/bi/order/details/${id}` })
  }
  //9610订单文件上传
  upload9610Order(data: any) {
    return this.post({ url: '/service-order/exp/dec/customs/import/9610', data })
  }
  //9710订单文件上传
  upload9710Order(data: any) {
    return this.post({ url: '/service-order/exp/dec/customs/import/9610/0110', data })
  }
  //查询上传物流单证文件
  getLogisticsFileAddress(params: any) {
    return this.get({ url: `/service-order/exp/dec/customs/query/upload/file/`, params })
  }
  //更新上传物流单证文件
  updateLogisticsFileAddress(data: any) {
    return this.post({ url: '/service-order/exp/dec/customs/update/upload/file/', data })
  }

  // 委托单详情
  getOrderDetails(id: any) {
    return this.get({ url: `/service-order/exp/dec/customs/details/${id}` })
  }
  // 代理报关订单列表
  getDeclarationAgentList(page: number, data: any) {
    return this.post({ url: `/service-order/exp/dec/customs/agent/declaration/page/${page}`, data })
  }
  //增加获取商品编码
  getGoodsCustomsCode(params:any){
    return this.get({url:`/service-order/goods/classification/select/customsCode`,params})
  }
  //获取开票数据列表
  getInvoiceDataList(data: any){
    return this.post({ url: '/service-order/invoice/data/export/page', data })
  }
  //检查报关单是否生成
  postCheckCreate(data:any){
    return this.post({url:'/service-order/invoice/data/export/check',data})
  }
  //通过报关单生成开票数据
  postCreateInvoiceData(data:any){
    return this.post({url:'/service-order/invoice/data/export/add',data})
  }
  //导出Excel
  postExportExcel(data:any,responseType: any){
    return this.post({url:'/service-order/invoice/data/export/exportExcel',data,responseType})
  }
  //获取开票数据明细信息
  getInvoiceDataDetail(id:String){
    return this.get({ url: `/service-order/invoice/data/export/info/${id}` })
  }
  //获取税务编码列表
  getTaxCodeList(data:any){
    return this.post({url:'/declaration/tax-code/page',data})
  } 
  //发送AI匹配税收编码
  postSendQueryTaxCode(itemName:String){
    return this.post({url:`/service-order/invoice/data/export/sendQueryTaxCode/${itemName}`})
  }
  //查询税收编码
  postQueryTaxCode(itemName:String){
    return this.post({url:`/service-order/invoice/data/export/queryTaxCode/${itemName}`})
  }
  //更新税收编码
  postUpdateTaxCode(data:any){
    return this.post({url:'/service-order/invoice/data/export/updateTaxCode',data})
  }

  //导出出口报关单
  postExportDeclare(data:any, responseType: any){
    return this.post({ url: `/declaration/exportList`, data , responseType})
  }
  //获取报关单列表
  getOrderList(data: any) {
    return this.post({ url: `/declaration/page`, data })
  }
  //智能匹配 查询报关单
  getMatchDeclareList(data:any){
    return this.post({ url: `/declaration/query/smart/match/declaration`, data })
  }
  //报关单智能匹配提交
  postMatchDelcalration(data:any){
    return this.post({url:`/declaration/smart/match/declaration`,data})
  }
  //报关单查询：委托单采购，销售订单信息
  getDeclareRelationOrder(expDeclarationId: string) {
    return this.get({ url: `/declaration/query/document/filing/${expDeclarationId}` })
  }
  //发送单证备案
  getSendOrder(expDeclarationId: string) {
    return this.get({ url: `/declaration/send/document/filing/${expDeclarationId}` })
  }
  //报关委托获取报关草单列表
  getDeclareList(page: number, data: any) {
    return this.post({ url: `/declaration/delegate/page/${page}`, data })
  }
  //查询归类报关单
  getClassifyDeclareList(data: any) {
    return this.post({ url: `/declaration/mh/delegate/page`, data })
  }
  //报关商品智能归类
  postDeclareSmartClassify(data: any) {
    return this.post({ url: `/declaration/smart/classify/goods/`, data })
  }
  //报关查询智能归类结果
  getDecalareClassificationInfo(params: any) {
    return this.get({ url: `/declaration/query/smart/goods/`, params })
  }
  //智能归类 确认归类(报关)
  postDeclareEntrustClassify(data: any) {
    return this.post({ url: `/declaration/entrust/smart/classify/goods/`, data })
  }
  //报关委托上传报关草单
  upLoadDeclare(data: any, token?: string, reftoken?: string) {
    return this.post({ url: '/declaration/upload/declare/excel/', data, headers: { token, reftoken } })
  }
  //报关委托提交取消草单事件
  postDeclareEvent(data: any) {
    return this.post({ url: `/declaration/declare/state/machine/send_event_local`, data })
  }
  //报关委托状态列表
  getDeclareStateList() {
    return this.get({ url: '/declaration/common/state' })
  }
  //校验企业的”增值税企业类型”、”企业退税地区”、”企业邮箱”信息
  getCheckCompanyInfo() {
    return this.get({ url: '/declaration/check' })
  }

  // -----------跨界电商模块相关接口------------
  //订单列表
  getSalesOrderList(page: number, data: any) {
    return this.post({ url: `/declaration/sales/order/page/${page}`, data })
  }
  //订单列表详情
  getSalesOrderDetail(id: string) {
    return this.get({ url: `/declaration/sales/order/info/${id}` })
  }
  //运单列表
  getWaybillList(page: number, data: any) {
    return this.post({ url: `/declaration/waybill/page/${page}`, data })
  }
  //运单列表详情
  getWaybillDetail(id: string) {
    return this.get({ url: `/declaration/waybill/info/${id}` })
  }
  //清单列表
  getCheckLsit(page: number, data: any) {
    return this.post({ url: `/declaration/exp/dec/manifest/page/${page}`, data })
  }
  //清单列表详情
  getCheckDetail(id: string) {
    return this.get({ url: `/declaration/exp/dec/manifest/info/${id}` })
  }
  //清单总分单列表
  getTotalList(page: number, data: any) {
    return this.post({ url: `/declaration/exp/dec/manifest/rollup/page/${page}`, data })
  }
  //清单总分单详情
  getTotalDetail(id: string) {
    return this.get({ url: `/declaration/exp/dec/manifest/rollup/info/${id}` })
  }
  //运抵单列表
  getArrivalList(page: number, data: any) {
    return this.post({ url: `/declaration/arrival/voucher/page/${page}`, data })
  }
  //运抵单详情
  getArrivalDetail(id: string) {
    return this.get({ url: `/declaration/arrival/voucher/info/${id}` })
  }
  //离境单列表
  getDepartureList(page: number, data: any) {
    return this.post({ url: `/declaration/departure/voucher/page/${page}`, data })
  }
  //离境单详情
  getDepartureDetail(id: string) {
    return this.get({ url: `/declaration/departure/voucher/info/${id}` })
  }
  //汇总申请单列表
  getSummaryApplicationList(page: number, data: any) {
    return this.post({ url: `/declaration/rollup/apply/page/${page}`, data })
  }
  //汇总申请单详情
  getSummaryApplicationDetail(id: string) {
    return this.get({ url: `/declaration/rollup/apply/info/${id}` })
  }
  //入库类型
  getSaveType() {
    return this.get({ url: `/declaration/common/saveType` })
  }
  //业务状态
  getBusinessStatus() {
    return this.get({ url: `/declaration/common/businessStatus` })
  }

 //  -------------金融服务模块信息查询授权
//建档信息存储
postAuthorizationSave(data:any){
  return this.post({ url: `/declaration/psbc/auth/save`, data })
}
//查询建档信息
postQueryAuthoInfo(){
  return this.post({ url: `/declaration/psbc/auth/query`})
}
//授权书查询
getAuthBookContent(){
  return this.get({url:`/declaration/psbc/auth/queryCustomerAuthorizations`})
}
//证件上传
postCertificateUpload(data:any){
  return this.post({ url: `/declaration/psbc/auth/b/file/seaport/upload`, data })
}


  //获取明灏服务单列表
  getServiceOrdersAll(page: number, data: any) {
    return this.post({ url: `/service-order/exp/dec/customs/order/all/page/${page}`, data })
  }
  //报关单 委托单比对
  getOrderMadeResult(orderId: string, uniformNo: string) {
    return this.get({ url: `/service-order/declaration/order/compared/${orderId}/${uniformNo}` })
  }
  //通过服务的统一编号报关单 委托单比对
  getOrderMadeResultByUniform(orderId: string, uniformNo: string) {
    return this.get({ url: `/service-order/declaration/order/query/compared/${orderId}/${uniformNo}` })
  }
  //报关单 服务单 商品查询
  getDeclarationServiceMembers(orderId: string, declarationId: string) {
    return this.get({ url: `/service-order/declaration/order/query/member/${orderId}/${declarationId}` })
  }

  //获取匹配完成的报关单和服务单
  getMadeSuccessOrder(orderId: string) {
    return this.get({ url: `/service-order/declaration/order/query/success/${orderId}` })
  }
  //通过委托单信息获取报关单列表
  getDeclareOrderListByService(data: any) {
    return this.post({ url: `/service-order/declaration/order/query/declaration`, data })
  }
  //根据报关单明细生成委托单
  postCreateServiceOrder(data: any) {
    return this.post({ url: `/service-order/exp/order/member/create/saleOrderMember`, data })
  }
  //根据报关单增减生成委托单
  postCreateServiceOrderBySaleOrderMember(data: any) {
    return this.post({ url: `/service-order/exp/order/member/modify/BySaleOrderMember`, data })
  }
  //关联采购订单生成委托单
  postCreateServiceOrderByPurchase(data: any) {
    return this.post({ url: `/service-order/exp/order/member/create/byPurchaseOrderMember`, data })
  }
  //合并订单
  postMergeExpMember(data: any) {
    return this.post({ url: `/service-order/exp/order/member/exp/merge/forExpMember`, data })
  }
  //确定添加商品校验
  postForExpMemberValidate(data:any){
    return this.post({ url: `/service-order/exp/order/member/exp/merge/forExpMember/validate`, data })
  }
  //1039合并商品
  postMerge1039ExMembers(data: any) {
    return this.post({ url: `/service-order/exp/order/member/merge/A1039/expDecMembers`, data })
  }
  //取消1039合并商品
  postMergeCancel1039ExMembers(data: any) {
    return this.post({ url: `/service-order/exp/order/member/cancel/merge/A1039/expDecMembers`, data })
  }
  //复制委托单
  postCopyServiceOrder(params: any) {
    return this.post({ url: `/service-order/exp/dec/customs/create/copy/order`, params })
  }
  //强制匹配
  postUpdateServiceGoods(data: any) {
    return this.post({ url: `/service-order/exp/order/member/modify/byDeclaration/goodsDesc`, data })
  }
  //删除委托单明细
  postDelServiceOrderGoods(data: any) {
    return this.post({ url: `/service-order/exp/order/member/delete/byExpOrderMemberIds`, data })
  }
  //根据统一编码查询报关单详情
  getDeclareDetail(uniformNo: string) {
    return this.get({ url: `/declaration/query/${uniformNo}` })
  }

  //获取fap报关单列表
  getfapOrderList(data: any) {
    return this.post({ url: `/bi/declaration/page`, data })
  }
  //获取退税申报明细
  getRefundDetail(cousNo: string) {
    return this.get({ url: `/bi/longtu/tax/refund/${cousNo}` })
  }
  //获取退税进度
  getProgressList(params:any){
    return this.get({ url: `/bi/longtu/tax/list`,params})
  }
  //获取9610报关单详情
  get9610Detail(id: string) {
    return this.get({ url: `/declaration/get9610/${id}` })
  }
  //获取fap9610报关单详情
  getfap9610Detail(id: string) {
    return this.get({ url: `/bi/declaration/get9610/${id}` })
  }
  //获取0110或者9710报关单详情
  get0110Or9710Detail(id: string) {
    return this.get({ url: `/declaration/get0110/or/9710/${id}` })
  }
  //获取fap0110或者9710报关单详情\
  getfap0110Or9710Detail(id: string) {
    return this.get({ url: `/bi/declaration/get0110/or/9710/${id}` })
  }
  // 订单跟踪
  getOrderStateList(id: string) {
    return this.get({ url: `/service-order/exp/dec/customs/state/record/${id}` })
  }

  //拼箱标识  下拉框
  getOrderContainerType() {
    return this.get({ url: '/service-order/exp/dec/common/container/order/type' })
  }

  // 获取个人协议列表
  getPersonalList(page: number, data: any) {
    return this.post({ url: `/bi/personal/search/${page}`, data })
  }
  // 获取个人协议状态
  getPersonalStatus() {
    return this.get({ url: '/bi/personal/status' })
  }
  // 更新个人协议到期时间
  updateAuthTerm(data: any) {
    return this.put({ url: `/bi/personal/updateAuthTerm`, data })
  }
  // 获取国际运单列表
  postGlobalPage(data: any) {
    return this.post({ url: `/service-order/inlet/waybill/page/global`, data })
  }
  // 获取国内运单列表
  postInternalPage(data: any) {
    return this.post({ url: `/service-order/inlet/waybill/page/internal`, data })
  }
  // 新增国际运单列表
  postSaveGlobal(data: any) {
    return this.post({ url: `/service-order/inlet/waybill/save/global`, data })
  }
  // 新增国内运单列表
  postSaveInternal(data: any) {
    return this.post({ url: `/service-order/inlet/waybill/save/internal`, data })
  }
  // 获取委托单列表
  postOrderWaybillList(data: any) {
    return this.post({ url: `/service-order/inlet/order/page/waybill/no`, data })
  }
  // 删除单条委托单
  postDeleteWaybillOrder(data: any) {
    return this.post({
      url: `/service-order/inlet/waybill/delete/inletWaybillOrder`,
      data,
      headers: { 'content-type': 'application/x-www-form-urlencoded' }
    })
  }
  // 获取国际运单详情
  getGlobalDetails(id: any) {
    return this.get({ url: `/service-order/inlet/waybill/details/global/${id}` })
  }
  // 获取国内运单详情
  getInternalDetails(id: any) {
    return this.get({ url: `/service-order/inlet/waybill/details/internal/${id}` })
  }
  // 编辑国际运单
  updateWaybillGlobal(data: any) {
    return this.post({ url: `/service-order/inlet/waybill/update/global`, data })
  }
  // 编辑国内运单
  updateWaybillInternal(data: any) {
    return this.post({ url: `/service-order/inlet/waybill/update/internal`, data })
  }
  // 报关单列表-关联单证
  getDeclarationRelationMembers(params: any) {
    return this.get({ url: `/declaration/dec/member/query/relation/members`, params })
  }
  // 报关单列表-报关单商品信息-添加采购商品
  postDeclarationPurMembers(data: any) {
    return this.post({ url: `/declaration/dec/member/query/pur/members`, data })
  }
  // 报关单列表-报关单商品信息-添加销售商品
  postDeclarationSalesMembers(data: any) {
    return this.post({ url: `/declaration/dec/member/query/sales/members`, data })
  }
  // 报关单列表-报关单商品信息-关联商品详情
  getDeclarationLedgerAriti(params: any) {
    return this.get({ url: `/declaration/dec/member/query/members/ledger/arti`, params })
  }
  // 报关单列表-报关单商品信息-关联采购/销售商品-保存按钮
  postDeclarationSalesLedger(data: any) {
    return this.post({ url: `/declaration/dec/member/link/pur/or/sales/ledger`, data })
  }
  // 报关单列表-报关单商品信息-关联采购/销售商品-删除所有关联
  postDeclarationDelterLedger(data: any) {
    return this.post({ url: `/declaration/dec/member/delete/pur/or/sales/ledger`, data })
  }
  // 报关单列表-报关单商品信息-关联订仓单-查询订仓商品
  postDeclarationBooking(data: any) {
    return this.post({ url: `/declaration/dec/member/query/booking/order/members/for/dec`, data })
  }
  /*===================订单管理end=======================*/

  //获取电商报价单状态
  getQuotationState() {
    return this.get({ url: '/bi/ecep/get/status' })
  }
  //获取电商报价单
  postQuotations(data: any) {
    return this.post({ url: `/bi/ecep/page/quotation`, data })
  }
  //获取电商报价单详情
  getQuotationsDetail(id: string) {
    return this.get({ url: `/bi/ecep/get/quotation/${id}` })
  }
  //获取科目
  getSubject() {
    return this.get({ url: `/bi/common/accounting/subject` })
  }
  //获取科目代码
  getSubjectCode() {
    return this.get({ url: '/bi/common/accounting/subject/code' })
  }
  //获取凭证类型
  getVoucherType() {
    return this.get({ url: '/bi/common/voucher/type' })
  }
  //获取流水账类型
  getFlowBookType() {
    return this.get({ url: '/bi/common/balance/type' })
  }
  //获取流水账单
  postAccountList(data: any) {
    return this.post({ url: `/bi/accounting/account/page`, data })
  }
  //获取流水账单详情
  getAccountDetail(id: string) {
    return this.get({ url: `/bi/accounting/account/${id}` })
  }
  //获取分类账列表
  postLegerAccountList(data: any) {
    return this.post({ url: `/bi/accounting/ledger/page`, data })
  }
  //获取分类账列表详情
  getLegerAccountDetail(id: string) {
    return this.get({ url: `/bi/accounting/ledger/${id}` })
  }
  //获取亚马逊是否授权
  // getAuthorization(){
  //   return this.get({url:'/amazon-auth/amazon/is/authorization'})
  // }

  //xiug店铺
  postUpdateShop(data: any) {
    return this.post({ url: '/amazon-auth/auth/update', data })
  }

  //删除店铺
  getDelShop(params: any) {
    return this.post({ url: '/amazon/delete', params })
  }

  //提交授权
  postAuthorizationInfo(data: any) {
    return this.post({ url: '/amazon/mh_inner_api/authorization', data })
  }

  getPostAuthorization(data: any) {
    return this.post({ url: '/amazon/authorization', data })
  }
  //获取亚马逊销售数据列表
  getAmazonSalesData( data: any) {
    return this.post({ url: `/bi/business/count/data/page`, data })
  }
  //获取亚马逊 区域
  getAuthorizationMarketplace() {
    return this.get({ url: '/amazon-auth/area/query/marketplace' })
  }
  //获取亚马逊 通过选择后区域 授权
  getAuthorization(amazonMarketplace: String) {
    return this.get({ url: `/amazon-auth/amazon/get/authorization/${amazonMarketplace}` })
  }
  //获取亚马逊 信息列表
  getAuthorizationList( data: any) {
    return this.post({ url: `/amazon-auth/auth/page`, data })
  }

  //获取汇率统计列表
  getRateDataList(data: any) {
    return this.post({ url: `/bi/business/count/data/exchange/page`, data })
  }

  //-----------------订单功能模块---------------------
  //新增销售订单
  postAddSaleOrder(data: any) {
    return this.post({ url: '/service-order/sales/order/save', data })
  }
  //更新销售订单
  postUpdateSaleOrder(data: any) {
    return this.post({ url: '/service-order/sales/order/update', data })
  }

  //销售订单备案获取订单列表
  postGetOrderList(data: any) {
    return this.post({ url: `/service-order/sales/order/page`, data })
  }
  //匹配销售订单获取订单列表
  postGetMadeSaleOrderList(data: any) {
    return this.post({ url: '/service-order/sales/order/page/merged/list', data })
  }
  //获取销售订单商品
  getSaleOrderMembers(params: any) {
    return this.get({ url: `/service-order/sales/order/member/query/listForExp`, params })
  }
  //查询销售订单商品详情
  postQuerySaleOrderMembers(data: any, saleOrderMemberId: String) {
    return this.post({ url: `/service-order/sales/order/member/query/detail/${saleOrderMemberId}`, data })
  }
  //根据商品名称获取商品
  getSaleOrderMembersByName(params: any) {
    return this.get({ url: `/service-order/sales/order/member/query/saleMember/byName`, params })
  }
  //更加销售订单id查询商品
  getSaleOrderMembersById(params: any) {
    return this.get({ url: `/service-order/sales/order/member/query/list`, params })
  }
  //销售订单新增商品根据商商品名查询可选择的SKU
  getSaleOrdergoodsSkuList(params: any) {
    return this.get({ url: `/service-order/sales/order/member/query/goodsDesc/byName`, params })
  }
  //销售订单新增商品根据商品名和商品SKU查询可关联的采购商品
  getPurchaseGoodsByNameAndGoodsSku(params: any) {
    return this.get({ url: `/service-order/sales/order/member/query/purGoods/byNameAndGoodsDesc`, params })
  }
  //销售订单导入
  postOrderImport(data: any) {
    return this.post({ url: '/service-order/sales/order/import/excel', data })
  }
  //获取订单详情
  getOrderDetail(id: string) {
    return this.get({ url: `/service-order/sales/order/details/${id}` })
  }
  //删除销售订单
  deleteOrder(data: any) {
    return this.delete({
      url: '/service-order/sales/order/delete',
      data,
      headers: { 'content-type': 'application/x-www-form-urlencoded', Authorization: '' }
    })
  }

  //委托单 查询绑定的销售订单
  getOrderByserviceOrder(params: any) {
    return this.get({ url: `/service-order/exp/dec/customs/query/exp/salesOrders/`, params })
  }

  //-------------------
  //获取币种对汇率
  getrateByCurrency(params: any) {
    return this.get({ url: `/service-order/exp/dec/customs/query/rateByCurrency`, params })
  }
  //新增采购订单
  postAddPurchaseOrder(data: any) {
    return this.post({ url: '/service-order/purchase/order/save', data })
  }
  //更新采购订单
  postUpdatePurchaseOrder(data: any) {
    return this.post({ url: '/service-order/purchase/order/update', data })
  }
  //采购订单备案获取采购订单列表
  postPurchaseOrderList(data: any) {
    return this.post({ url: `/service-order/purchase/order/page`, data })
  }
  //匹配采购订单获取采购订单列表
  postMadePurchaseOrderList(data: any) {
    return this.post({ url: `/service-order/purchase/order/query/purchaseOrders/forExpOrder`, data })
  }
  //获取采购订单商品
  getPurchaseOrderMembers(params: any) {
    return this.get({ url: `/service-order/purchase/order/member/query/classification/purMemberById`, params })
  }
  //根据商品名称获取商品
  getPurchaseOrderMembersByName(params: any) {
    return this.get({ url: `/service-order/purchase/order/member/query/byName`, params })
  }
  //导入采购订单
  postImportPurchaseOrder(data: any) {
    return this.post({ url: '/service-order/purchase/order/import/excel', data })
  }
  //获取采购订单详情
  getPurchaseOrderDetail(id: string) {
    return this.get({ url: `/service-order/purchase/order/details/${id}` })
  }
  //删除采购订单
  deletePurchaseOrder(data: any) {
    return this.delete({
      url: '/service-order/purchase/order/delete',
      data,
      headers: { 'content-type': 'application/x-www-form-urlencoded', Authorization: '' }
    })
  }
  // -----------------出口委托单匹配订仓单-----------------
  //获取订仓单
  getBookingOrdersList(data: any) {
    return this.post({ url: `/service-order/exp/order/member/query/bookingOrder`, data })
  }
  getBookingOrderMembers(data: any) {
    return this.post({ url: `/service-order/exp/order/member/query/bookingOrderMember`, data })
  }
 // -----------------出口委托单汇总详情-----------------
 //根据出口委托单id 查询对应的销售订单编号
 getSaleOrderNos(params:any){
  return this.get({ url: `/service-order/exp/dec/customs/getSaleOrderNos`, params })
 }
 //根据编号查询销售订单详情
 getSaleOrderDetailByNo(params:any){
  return this.get({ url: `/service-order/sales/order/details/0`, params })
 }
 //根据出口委托单id 查询对应的采购订单编号
 getPurchaseOrderNos(params:any){
  return this.get({ url: `/service-order/exp/dec/customs/getPurchaseOrderNos`, params })
 }
 //根据编号查询采购订单详情
 getPurchaseOrderDetailByNo(params:any){
  return this.get({ url: `/service-order/purchase/order/details/0`, params })
 }

 //根据出口委托单id 查询对应的订仓单编号
 getBookingOrderNos(params:any){
  return this.get({ url: `/service-order/exp/dec/customs/getOrderWarehouseReceiptNos`, params })
 }
 //根据编号查询订仓单详情
 getBookingOrderDetailByNo(params:any){
  return this.get({ url: `/service-order/booking/order/query/order/detail`, params })
 }
//根据编号查询报关单列表
getDeclareTaleData(page:Number,params:any){
  return this.get({ url: `/service-order/exp/dec/customs/declarationPage/${page}`, params })
}
 //根据出口委托单id 查询对应的提运单编号
 getBillOrderNos(params:any){
  return this.get({ url: `/service-order/exp/dec/customs/getBillLadeNos`, params })
 }
  //根据编号查询提运单详情
 getBillOrderDetail(params:any){
  return this.get({ url: `/service-order/lading/bill/info/0`, params })
 }
  //根据出口委托单id 查询对应的委托协议编号
  getAgreementsNos(params:any){
    return this.get({ url: `/service-order/exp/dec/customs/getAgreementNos`, params })
  }
  //根据编号查询委托协议详情
  getAgreementDetail(params:any){
    return this.get({ url: `/service-order/dec/agreement/info/0`, params })
  }


  // -----------------客服管理-----------------
  // 获取客服列表
  postCustomerPage(data: any) {
    return this.post({ url: '/saas/customer/page', data })
  }
  // 更新客服信息
  updateCustomer(params: any) {
    return this.get({ url: '/saas/customer/refresh', params })
  }
  // 绑定用户
  postBindCustomer(data: any) {
    return this.post({ url: '/saas/customer/bind', data })
  }
  // 获取问诊信息
  getConsultInfo(personId: any) {
    return this.get({ url: `/saas/personalInfo/${personId}` })
  }

  // -----------------平台方功能模块---------------------
  // 平台方列表查询
  getOrganizationList(data: any, page: any) {
    return this.post({ url: `/saas/organization/platform/config/page/${page}`, data })
  }
  // 平台方编辑
  editOrganization(data: any) {
    return this.post({ url: '/saas/organization/platform/config/edit', data })
  }
  // 新增平台方
  addOrganization(data: any) {
    return this.post({ url: '/saas/organization/platform/config/add', data })
  }
  // 平台方详情
  detailOrganization(id: any) {
    return this.get({ url: `/saas/organization/platform/config/info/${id}` })
  }
  // 根据名称查询企业{name}
  getLegalize(name: any) {
    return this.get({ url: `/saas/organization/legalizeList/${name}` })
  }

  // -----------------订单支付记录功能模块---------------------
  // 获取订单支付列表
  getOrderPage(data: any) {
    return this.post({ url: '/saas/order/page', data })
  }
  // 获取活动列表
  getSourcePage() {
    return this.get({ url: '/saas/order/source/get' })
  }
  // 获取销售渠道列表
  getOrderSale() {
    return this.get({ url: '/saas/order/sale/list' })
  }
  // 导出订单列表
  pstExportOrderData(data: any, responseType: any) {
    return this.post({ url: '/saas/order/export', data, responseType })
  }

  // -----------------渠道列表功能模块---------------------
  // 获取渠道列表
  getSalePage(data: any) {
    return this.post({ url: '/saas/order/sale/page', data })
  }
  // 新增渠道
  postAddSale(data: any) {
    return this.post({ url: '/saas/order/sale/add', data })
  }
  // 更新渠道
  postUpdateSale(data: any) {
    return this.post({ url: '/saas/order/sale/update', data })
  }

  // -----------------活动列表功能模块---------------------
  // 获取活动列表
  postActivePage(data: any) {
    return this.post({ url: '/saas/active/page', data })
  }
  // 新增活动
  postAddActive(data: any) {
    return this.post({ url: '/saas/active/add', data })
  }
  // 活动详情
  getActiveDetail(params: any) {
    return this.get({ url: `/saas/active/detail`, params })
  }
  // 编辑活动列表
  postUpdateActive(data: any) {
    return this.post({ url: '/saas/active/update', data })
  }
  // 活动对应绑定渠道列表
  getActiveSaleList(params: any) {
    return this.get({ url: '/saas/active/sale/list', params })
  }
  // 保存活动渠道
  postAddActiveSale(data: any) {
    return this.post({ url: '/saas/active/sale/add', data })
  }
  // 删除活动渠道
  postDelActiveSale(data: any) {
    return this.post({ url: '/saas/active/sale/delete', data })
  }

  //-----------------微信公众号自定义菜单模块---------------------
  // 获取消息列表
  getWechatQueryEvent(data: any) {
    return this.post({ url: '/bi/wechat/query/event', data })
  }
  // 新获取消息列表
  getWechatPageEvent(data: any) {
    return this.post({ url: '/bi/wechat/page/event', data })
  }
  // 删除消息
  postDelWeChatEvent(id: any) {
    return this.post({ url: `/bi/wechat/delete/content/${id}` })
  }
  // 删除规则消息
  postDelEventRuleName(ruleName: any) {
    return this.post({ url: `/bi/wechat/delete/event/${ruleName}` })
  }
  // 根据事件删除消息
  postDelEventName(ruleName: any, event: any) {
    return this.post({ url: `/bi/wechat/delete/event/${ruleName}/${event}` })
  }
  // 编辑消息
  postUpdateWeChatEvent(data: any) {
    return this.post({ url: `/bi/wechat/update/event`, data })
  }
  // 获取菜单列表
  getWechatQueryMenu() {
    return this.get({ url: '/bi/wechat/query/menu' })
  }
  // 修改菜单列表
  postUpdateMenu(data: any) {
    return this.post({ url: `/bi/wechat/update/menu`, data })
  }
  // 上传素材
  getWechatUpload(data: any) {
    return this.post({ url: '/wechat-mp/wechat/menu/upload', data })
  }

  //-----------------订仓单功能模块---------------------
  //新增订仓单
  postAddBookingOrder(data: any) {
    return this.post({ url: '/service-order/booking/order/add/order', data })
  }
  //查询订仓单列表
  getBookingOrderList(data: any) {
    return this.post({ url: '/service-order/booking/order/query/order/list', data })
  }
  //查看订仓单详情
  getQueryBookingOrderDetail(params: any) {
    return this.get({ url: '/service-order/booking/order/query/order/detail', params })
  }
  //删除订仓单
  postDelBookingOrder(data: any) {
    return this.post({ url: '/service-order/booking/order/delete/order/list', data })
  }
  //合并订仓单
  postMergeBookingOrder(data: any) {
    return this.post({ url: '/service-order/booking/order/create/order/for/purchase', data })
  }

  //-----------------提运单功能模块---------------------
  //新增提运单
  postAddBillOfLading(data: any){
    return this.post({ url: '/service-order/lading/bill/add', data })
  }
  //编辑提运单
  postUpdateBillOfLading(data: any){
    return this.post({ url: '/service-order/lading/bill/edit', data })
  }
  //删除提运单
  deleteBillOfLading(id:String){
    return this.delete({url:`/service-order//lading/bill/remove/${id}`})
  }

  //查询提运单列表
  getBillOfLadingList(data:any){
    return this.post({url:`/service-order/lading/bill/page/`,data})
  }
  //查询提运单详情
  getBillOfLadingDetail(id:String){
    return this.get({url:`/service-order/lading/bill/info/${id}`})
  }
  //获取关联报关单
  getBillDeclareList(data:any){
    return this.post({url:`/service-order/lading/bill/rel/info/${data.ladingBillId}`,data})
  }
   //获取关联报关单
   getEntrustMentDeclareList(data:any){
    return this.post({url:`/service-order/dec/agreement/rel/info/${data.declarationAgreementId}`,data})
  }
  //新增关联报关单
  postRelationDeclare(data:any){
    return this.post({url:`/service-order/lading/bill/add/rel`,data})
  }
  //取消关联报关单
  postCancelRelDeclare(data:any){
    return this.post({url:`/service-order/lading/bill/remove/rel`,data})
  }

  //-----------------报关委托协议功能模块---------------------
  //新增报关委托
  postAddDelcarationEntrustment(data:any){
    return this.post({ url: '/service-order/dec/agreement/add', data })
  }
  //编辑报关委托
  postUpdateDelcarationEntrustment(data:any){
    return this.post({ url: '/service-order/dec/agreement/edit', data })
  }
  //删除报关委托
  deleteDelcarationEntrustment(id:String){
    return this.delete({url:`/service-order/dec/agreement/remove/${id}`})
  }
  //获取报关委托协议列表
  getDelcarationEntrustmentList(data:any){
    return this.post({url:`/service-order/dec/agreement/page`,data})
  }
  //获取报关委托协议详情
  getDelcarationEntrustmentDetail(id:String){
    return this.get({url:`/service-order/dec/agreement/info/${id}`})
  }
   //新增关联报关单
   postAgreeRelationDeclare(data:any){
    return this.post({url:`/service-order/dec/agreement/add/rel`,data})
  }
  //取消关联报关单
  postAgreeCancelRelDeclare(data:any){
    return this.post({url:`/service-order/dec/agreement/remove/rel`,data})
  }
  
   
  //-------------------
  //新增退税参数
  postAddTaxRefund(data: any) {
    return this.post({ url: '/bi/taxRefund/create/annualExportSales', data })
  }
  //更新退税参数
  postUpdateTaxRefund(data: any) {
    return this.post({ url: '/bi/taxRefund/update/annualExportSales', data })
  }
  //查询退税参数列表
  getTaxRefundList(params: any) {
    return this.get({ url: '/bi/taxRefund/query/annualExportSales', params })
  }
  //删除退税参数
  deleteTaxRefund(operatingYear: any) {
    return this.get({ url: `/bi/taxRefund/delete/annualExportSales/${operatingYear}` })
  }
  //查询已存在年份
  getAnnualExportYears() {
    return this.get({ url: '/bi/taxRefund/query/annualExportYears' })
  }

  // ----------------亚马逊订单数据功能模块---------------------
  // 订单列表
  postAmazonOrderPage(data: any) {
    return this.post({ url: `/amazon-auth/order/page`, data })
  }
  // 订单类型
  getAmazonOrderTypes(params: any) {
    return this.get({ url: '/amazon-auth/order/types', params })
  }
  // 订单状态
  getAmazonOrderStatus(params: any) {
    return this.get({ url: '/amazon-auth/order/status', params })
  }
  // 订单详情
  getAmazonOrderDetail(id: any) {
    return this.get({ url: `/amazon-auth/order/info/${id}` })
  }

  // ----------------收款单功能模块---------------------
  // 收款单列表
  getReceiptPage(data: any) {
    return this.post({ url: `/service-order/receipt/page`, data })
  }
  // 新增收款单
  addReceipt(data: any) {
    return this.post({ url: `/service-order/receipt/add`, data })
  }
  // 删除收款单
  deleteReceipt(data: any) {
    return this.post({ url: `/service-order/receipt/delete`, data })
  }
  // 编辑收款单
  upDateReceipt(data: any) {
    return this.post({ url: `/service-order/receipt/update`, data })
  }
  // 获取收款单详情
  getReceiptDetails(params: any) {
    return this.get({ url: `/service-order/receipt/details`, params })
  }

  // ----------------出口委托单 9610报文数据功能模块---------------------
  // 获取订单列表
  getSalesOrderInfo(expOrderId: any) {
    return this.get({ url: `/service-order/exp/dec/customs/sales/order/info/${expOrderId}` })
  }
  // 获取运单列表
  getCustomsWayBillInfo(expOrderId: any) {
    return this.get({ url: `/service-order/exp/dec/customs/waybill/info/${expOrderId}` })
  }
  // 获取清单列表
  getMainIfEstInfo(expOrderId: any) {
    return this.get({ url: `/service-order/exp/dec/customs/exp/dec/manifest/info/${expOrderId}` })
  }
  // 获取清单总分单详情
  getManIfEstRollUpInfo(expOrderId: any) {
    return this.get({ url: `/service-order/exp/dec/customs/exp/dec/manifest/rollup/info/${expOrderId}` })
  }
  // 获取运抵单详情
  getArrivalVoucherInfo(expOrderId: any) {
    return this.get({ url: `/service-order/exp/dec/customs/arrival/voucher/info/${expOrderId}` })
  }
  // 获取离境单详情
  getDepartureVoucherInfo(expOrderId: any) {
    return this.get({ url: `/service-order/exp/dec/customs/departure/voucher/info/${expOrderId}` })
  }
  // 获取申请汇总单列表
  getRollUpApplyInfo(expOrderId: any) {
    return this.get({ url: `/service-order/exp/dec/customs/rollup/apply/info/${expOrderId}` })
  }
  // 获取收款单列表
  getExpReceiptInfo(expOrderId: any) {
    return this.get({ url: `/service-order/exp/dec/customs/receipt/info/${expOrderId}` })
  }

  //2023
  //企业信息---发票数量(订单模块)
  postInvoice(page: number, data: any) {
    return this.post({ url: `/service-order/data/order/organization/bill/page/${page}`, data })
  }
  //首页-订单总览
  getOrderSummary(params: any) {
    return this.get({ url: `/service-order/exp/dec/customs/check/order/summary`, params })
  }

  //快捷下单-出口商品列表-导入商品
  postExpDecMember(data: any) {
    return this.post({ url: `/service-order/exp/order/member/exp/import/expDecMember`, data })
  }
  //快捷下单-出口商品列表-新增商品
  postCacheExpDecMemberAdd(params: any, data: any) {
    return this.post({ url: `/service-order/exp/order/member/add/cache/expDecMember`, params, data })
  }
  //快捷下单-出口商品列表-清空商品
  postClearCacheExpDecMember(params: any) {
    return this.post({ url: `/service-order/exp/order/member/delete/all/cache/expDecMember`, params })
  }
  //快捷下单-出口商品列表-删除商品
  postDelCacheExpDecMember(data: any) {
    return this.post({ url: `/service-order/exp/order/member/delete/cache/expDecMembers`, data })
  }
  //快捷下单-出口商品列表
  postCacheExpDecMember(params: any) {
    return this.post({ url: `/service-order/exp/order/member/query/cache/expDecMember`, params })
  }
  //快捷下单-出口商品列表-补充信息
  postCacheUpdateExpDecMember(data: any) {
    return this.post({ url: `/service-order/exp/order/member/update/cache/expDecMembers`, data })
  }
  // 快捷下单 根据订单信息获取收款单信息 
  getReceiptSaleInfo(params: any) {
    return this.get({ url: `/service-order/receipt/details/sale`, params })
  }
  //报关单列表-物流查询-获取提单号
  getDeclarationNo(declarationNo: any) {
    return this.get({ url: `/transport/ydw/get/blNo/${declarationNo}` })
  }
  //开通物流协议-上传附件
  postAgreementUpload(data: any) {
    return this.post({ url: `/agreement/common/upload`, data })
  }
  //商品预归类 主列表
  postClassificationGoodsList(data: any) {
    return this.post({ url: `/service-order/goods/classification/query/classification/goodsList/`, data })
  }
  //商品预归类 委托及撤销委托
  postUpdateClassifyGoods(data: any) {
    return this.post({ url: `/service-order/goods/classification/update/classification/goods/`, data })
  }
  //商品预归类  状态列表
  postClassificationState(data: any) {
    return this.post({ url: `/service-order/goods/classification/query/classification/state/`, data })
  }
  //商品预归类 弹出层-详情
  getClassificationDetail(params: any) {
    return this.get({ url: `/service-order/goods/classification/select/goodsClassification/detail`, params })
  }
  //商品归类详情 快捷下单
  getClassificationDetailBySku(params: any) {
    return this.get({ url: `/service-order/goods/classification/select/goodsClassification/detail/bySku`, params })
  }
  //商品预归类 弹出层-提交
  getClassificationpostUpdateDetail(data: any) {
    return this.post({ url: `/service-order/goods/classification/update/goodsClassification/detail`, data })
  }
  // 商品预归类 弹出层-商品编号
  getClassificationSelect(params: any) {
    return this.get({ url: `/service-order/goods/classification/select/customsCode`, params })
  }
  // 商品预归类 弹出层-输入商品编号后返回的表单
  getClassificationCodeForm(params: any) {
    return this.get({ url: `/service-order/goods/classification/select/customsCode/codeDetail`, params })
  }
  // 商品归类 -新增商品
  postClassificationposAddGoods(data: any) {
    return this.post({ url: `/service-order/goods/classification/add/goods/`, data })
  }
  //商品归类 -批量智能归类-列表
  postClassificationImportList(data: any) {
    return this.post({ url: `/service-order/goods/classification/query/import/list`, data })
  }
  //商品归类 -批量智能归类-列表- 弹出层列表
  getClassificationSmartList(params: any) {
    return this.get({ url: `/service-order/goods/classification/query/smart/classification/list`, params })
  }
  //商品归类 -批量智能归类- 导入商品
  postClassificationImportFile(data: any) {
    return this.post({ url: `/service-order/goods/classification/import/classification/file`, data })
  }
  //商品归类 -批量智能归类- 导出
  getClassificationDownloadImportList(params: any) {
    return this.get({ url: `/service-order/goods/classification/download/import/list`, params })
  }
  //商品归类 -批量智能归类- 弹出层-一键归类
  postClassificationSmartOneKey(data: any) {
    return this.post({ url: `/service-order/goods/classification/smart/classify/list`, data })
  }
  //商品归类 -批量智能归类- 委托跨赋归类
  getClassificationEntrustClassified(params: any) {
    return this.get({ url: `/service-order/goods/classification/entrustClassified/import/list`, params })
  }
  //商品归类 -批量智能归类- 弹出层 跨赋 确认归类商品list
  postClassificationClassiftImportList(data: any) {
    return this.post({ url: `/service-order/goods/classification/classify/import/list`, data })
  }
  //商品归类 -批量智能归类- 弹出层 点击重试
  postClassificationRetry(data: any) {
    return this.post({ url: `/service-order/goods/classification/retry/classify/import/member`, data })
  }
  //商品归类 -新增商品-品牌类型
  getClassificationBrandType() {
    return this.get({ url: `/service-order/goods/classification/query/brand/type` })
  }
  //商品归类 - 删除商品/删除批量智能归类
  postClassificationDelete(data: any) {
    return this.post({ url: `/service-order/goods/classification/delete/classification/goods`, data })
  }

  //商品智能归类
  postOrderSmartClassify(data: any) {
    return this.post({ url: `/service-order/goods/classification/smart/classify/goods/`, data })
  }
  //查询智能归类结果
  getOrderClassificationInfo(params: any) {
    return this.get({ url: `/service-order/goods/classification/query/smart/goods/`, params })
  }
  //查询 根据六位海关编码查询十位海关编码
  getTenCodeList(params: any, token?: string, refreshToken?: string) {
    return this.get({
      url: `/service-order/goods/classification/query/ten/customs/code`,
      params,
      headers: { token: token, refreshToken: refreshToken }
    })
  }
  //查询 根据十位海关编码查询检疫代码
  getInspectionCode(params: any, token?: string, refreshToken?: string) {
    return this.get({
      url: `/service-order/goods/classification/query/inspection/code`,
      params,
      headers: { token: token, refreshToken: refreshToken }
    })
  }
  //智能归类 确认归类
  postOrderEntrustClassify(data: any) {
    return this.post({ url: `/service-order/goods/classification/entrust/smart/classify/goods/`, data })
  }
  //金融单 列表
  postFinancialOrderList(data: any) {
    return this.post({ url: `/service-order/financial/order/query/list`, data })
  }
  //金融单 详情
  getFinancialOrderDetail(id: any) {
    return this.get({ url: `/service-order/financial/order/details/${id}` })
  }
  //金融单 支用申请
  getFinancialOrderApply(data: any) {
    return this.post({ url: `/service-order/financial/order/apply`, data })
  }
  //金融单 授信信息查询
  getNoticeCreadit() {
    return this.get({ url: `/service-order/financial/order/notice/credit` })
  }
  //金融单 是否可测额
  getIsMeasuring() {
    return this.get({ url: `/service-order/financial/order/query/is/measuring` })
  }
  //金融单 授信信息查询->统计信息
  getOrderCountInfo() {
    return this.get({ url: `/service-order/financial/order/query/count/info` })
  }
  //金融单 测额
  postFinancialOrderCreate() {
    return this.post({ url: `/service-order/financial/order/create` })
  }
  //金融单 刷新状态
  getFinancialOrderApplyInfo(id: any) {
    return this.get({ url: `/service-order/financial/order/apply/info/${id}` })
  }
  //金融单 H5首页
  getFinancialOrderH5() {
    return this.get({ url: `/service-order/financial/order/h5` })
  }
  //金融单 H5详情
  getFinancialOrderH5Id(id: any) {
    return this.get({ url: `/service-order/financial/order/h5/${id}` })
  }
  //金融单 查询-状态列表
  getFinancialOrderState(id: any) {
    return this.get({ url: `/service-order/financial/order/state` })
  }
  // 邮汇万家 贷前数据查询
  getTransactionPreLoan (params: any) {
    return this.get({ url: `/declaration/transaction-data/preLoan`, params})
  }
  //金融单 邮储授信信息查询
  getNoticeCreaditPsbc() {
    return this.get({ url: `/service-order/financial/order/notice/credit/psbc` })
  }
  // 金融单 获取邮储 h5 地址
  getFinancialOrderH5Psbc () {
    return this.get({ url: `/service-order/financial/order/psbc/h5` })
  }

  //运单 -新增
  postAddWaybill(data: any) {
    return this.post({ url: `/service-order/way/bill/add`, data })
  }
  //运单 -列表
  postWaybillList(data: any) {
    return this.post({ url: `/service-order/way/bill/query/list`, data })
  }
  //运单 - 删除
  postDelWaybill(data: any) {
    return this.post({ url: `/service-order/way/bill/delete/byId`, data })
  }
  //运单 - 详情
  getDetailWaybill(params: any) {
    return this.get({ url: `/service-order/way/bill/query/byId`, params })
  }
  //运单 - 打包装车/清除装车信息
  postWaybill(data: any) {
    return this.post({ url: `/service-order/way/bill/update/carNo`, data })
  }
  queryLogistics(params:any){
    return this.get({url:`/service-order/way/bill/query/logisticsTrajectory`,params})
  }
  //委托单-查询物流企业运单编号
  getWayBillNo(params: any) {
    return this.get({ url: `/service-order/way/bill/query/wayBillNo`, params })
  }

  //运抵车辆列表
  postCarList(data: any) {
    return this.post({ url: `/service-order/car/list`, data })
  }
  //添加已运抵车辆
  postCarCreate(data: any) {
    return this.post({ url: `/service-order/car/create`, data })
  }
  //已运抵车辆 状态
  getCarArrivalStatus() {
    return this.get({ url: `/service-order/car/arrival/status` })
  }
  //已运抵车辆 操作
  postCarOperate(data: any) {
    return this.post({ url: `/service-order/car/operate`, data })
  }

  //已发运车辆列表
  postCarDepartureList(data: any) {
    return this.post({ url: `/service-order/car/departure/list`, data })
  }
  //已发运车辆车辆 状态
  getCarDepartureStatus() {
    return this.get({ url: `/service-order/car/departure/status` })
  }
  //已发运车辆车辆 操作
  postCarDepartureOperate(data: any) {
    return this.post({ url: `/service-order/car/departure/operate`, data })
  }
  //已发运车辆车辆 取消发运
  postCarDel(data: any) {
    return this.post({ url: `/service-order/car/delete`, data })
  }

  //通过车信息id查询运单
  getWaybillByCarInfoId(params: any) {
    return this.get({ url: `/service-order/way/bill/query/byCarInfoId`, params })
  }
  /* ------------------- 财务 start ----------------------*/
  //财务-发票管理-发票列表
  postBillList(data: any) {
    return this.post({ url: `/service-order/bill/query/list`, data })
  }
  //财务-发票管理-业务类型
  getBillBusinessType() {
    return this.get({ url: `/service-order/bill/query/businessType` })
  }
  //财务-发票管理-新增发票
  postBillAdd(data: any) {
    return this.post({ url: `/service-order/bill/add/bill`, data })
  }
  //财务-发票管理-详情
  getBillDetail(params: any) {
    return this.get({ url: `/service-order/bill/query/detail`, params })
  }
  //财务-发票管理-确认开票
  postBillUpdateStatus(data: any) {
    return this.post({ url: `/service-order/bill/update/status`, data })
  }
  //财务-付汇管理-付汇申请单列表
  postPaymentOrderList(data: any) {
    return this.post({ url: `/service-order/paymentOrder/query/list`, data })
  }
  //财务-付汇管理-付汇申请详情
  getPaymentOrderDetail(params: any) {
    return this.get({ url: `/service-order/paymentOrder/query/detail`, params })
  }
  //财务-付汇管理-付汇申请-提交/暂存
  postPaymentOrderSaveUpdate(data: any) {
    return this.post({ url: `/service-order/paymentOrder/save/or/update`, data })
  }
  //财务-付汇管理-查询支付方式
  getPaymentOrderPaymentPethod(data: any) {
    return this.get({ url: `/service-order/paymentOrder/query/paymentMethod`, data })
  }
  //财务-付汇管理-查询进口订单
  postPaymentOrderInletOrders(data: any) {
    return this.post({ url: `/service-order/paymentOrder/query/inlet/orders`, data })
  }
  //财务-付汇管理-查询进口订单商品
  postPaymentOrderInletMembers(data: any) {
    return this.post({ url: `/service-order/paymentOrder/query/inlet/members`, data })
  }
  /* ------------------- 财务 end ----------------------*/

  /* ------------------- 问诊模块 ----------------------*/
  // 获取当前客服状态
  getCsStatus() {
    return this.get({ url: `/saas/getCsStatus` })
  }
  // 获取客服列表
  getConversation(params: any) {
    return this.get({ url: `/saas/getConversation`, params })
  }
  // 获取对接客服状态
  getServiceState(params: any) {
    return this.get({ url: `/saas/getServiceState`, params })
  }
  // 获取聊天记录
  getMsgPage(data: any) {
    return this.post({ url: `/saas/getMsgPage`, data })
  }
  // 发送文本消息
  postSendText(data: any) {
    return this.post({ url: `/saas/sendText`, data })
  }
  // 发送图片消息
  postSendImage(data: any) {
    return this.post({ url: `/saas/sendImage`, data })
  }
  // 发送文件消息
  postSendFile(data: any) {
    return this.post({ url: `/saas/sendFile`, data })
  }
  // 撤回消息
  postRecallMsgFile(data: any) {
    return this.post({ url: `/saas/recallMsg`, data })
  }
  // 切换企业微信接待
  postTrans(data: any) {
    return this.post({ url: `/saas/trans`, data })
  }
  // 设置消息已读
  postRead(data: any) {
    return this.post({ url: `/saas/read`, data })
  }

  /* ------------------- 问诊end ----------------------*/

  // 大屏 图表
  getLargeScreen(data: any) {
    return this.get({ url: `/saas/largeScreen/data`, data })
  }
  //大屏 地图
  getLargeScreenMap(data: any) {
    return this.get({ url: `/saas/largeScreen/map`, data })
  }

  //检验检疫 列表
  postDeclarationIftdcliodeclList(data: any) {
    return this.post({ url: `/declaration/itf-dcl-io-decl/page`, data })
  }
  //检验检疫/属地查检 详情的所有下列
  getDeclarationCommonnDropDown() {
    return this.get({ url: `/declaration/common/drop/down` })
  }
  //检验检疫 暂存
  postDeclarationIftdcliodeclTemporaryStorage(data: any) {
    return this.post({ url: `/declaration/itf-dcl-io-decl/temporaryStorage`, data })
  }
  //检验检疫 详情
  postDeclarationIftdcliodeclDetail(itfDclIoDeclId: any) {
    return this.post({ url: `/declaration/itf-dcl-io-decl/details/${itfDclIoDeclId}` })
  }
  //检验检疫 删除
  postDeclarationIftdcliodeclDetailDel(id: any) {
    return this.post({ url: `/declaration/itf-dcl-io-decl/delete/itfDclIoDeclContDetail/${id}` })
  }
  postDeclarationIftdcliodeclCopy(id: any) {
    return this.post({ url: `/declaration/itf-dcl-io-decl/copy/${id}` })
  }
  //检验检疫 清空缓存 新增按钮
  postDeclarationIftdcliodeclCacheClear(docNo: any) {
    return this.post({ url: `/declaration/itf-dcl-io-decl/cache/clear/${docNo}` })
  }
  //检验检疫 缓存接口-新增检验检疫时，获取系统单号
  getDeclarationIftdcliodeclCacheDocNo() {
    return this.get({ url: `/declaration/itf-dcl-io-decl/cache/docNo` })
  }
  //检验检疫 上传
  postDeclarationUpload(data: any) {
    return this.post({ url: `/declaration/common/upload`, data })
  }
  //检验检疫 新增/编辑 缓存接口- 获取对应的type列表数据
  postDeclarationIftdcliodeclCacheList(docNo: any, type: any, typeId: any) {
    return this.post({ url: `/declaration/itf-dcl-io-decl/cache/query/${docNo}/${type}/${typeId}` })
  }
  //检验检疫  新增/编辑 缓存接口- 添加对应的type数据
  postDeclarationIftdcliodeclCacheAdd(data: any) {
    return this.post({ url: `/declaration/itf-dcl-io-decl/cache/add`, data })
  }
  //检验检疫  新增/编辑 缓存接口- 删除对应的type数据
  postDeclarationIftdcliodeclCacheDelete(data: any) {
    return this.post({ url: `/declaration/itf-dcl-io-decl/cache/delete`, data })
  }
  //检验检疫  详情， 海关编码
  getDeclarationCode(hs_code: any) {
    return this.get({ url: `/declaration/common/selectAllURL/${hs_code}` })
  }
  //检验检疫  详情， 根据海关编码获取详情和申报要素
  getDeclarationCodeDetail(hs_code: any) {
    return this.get({ url: `/declaration/common/codeDetail/${hs_code}` })
  }

  //属地查检 列表
  postDeclarationTecciqdeclList(data: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/page`, data })
  }
  //属地查检 详情
  postDeclarationTecciqdecDetail(tecCiqDecId: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/details/${tecCiqDecId}` })
  }
  //属地查检 删除
  postDeclarationTecciqdecDetailDel(params: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/delete/tecCiqDec`, params })
  }
  //属地查检 复制
  postDeclarationTecciqdecCopy(id: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/copy/${id}` })
  }
  //属地查检 清空缓存=新增按钮
  postDeclarationTecciqdecCacheClear(docNo: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/cache/clear/${docNo}` })
  }
  //属地查检 暂存
  postDeclarationTecciqdecTemporaryStorage(data: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/temporaryStorage`, data })
  }
  //属地查检 同步单一窗口
  postDeclarationTecciqdecSync(data: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/add`, data })
  }
  //属地查检 详情-状态查看
  postDeclarationTecciqdecStatus(tecCiqDecId: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/status/${tecCiqDecId}` })
  }
  //属地查检 缓存接口- 获取对应的type列表数据
  postDeclarationTecciqdecCacheList(data: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/cache/query`, data })
  }
  //属地查检 缓存接口- 复制
  postDeclarationTecciqdecCacheCopy(data: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/cache/copy`, data })
  }
  //属地查检 缓存接口- 获取详情集装箱列表数据
  postDeclarationTecciqdecCacheContainerList(data: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/cache/count/container`, data })
  }
  //属地查检  新增/编辑 缓存接口- 添加对应的type数据
  postDeclarationTecciqdecCacheAdd(data: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/cache/add`, data })
  }
  //属地查检  删除 缓存接口- 删除对应的type数据
  postDeclarationTecciqdecCacheDelete(data: any) {
    return this.post({ url: `/declaration/tec-ciq-dec/cache/delete`, data })
  }
  //属地查检 缓存接口-新增属地查检时，获取系统单号
  getDeclarationTecciqdecCacheDocNo() {
    return this.get({ url: `/declaration/tec-ciq-dec/cache/docNo` })
  }
  //属地查检 -证书申请 -详情
  postDeclarationDfcApplyDetails(tecCiqDecId: any) {
    return this.post({ url: `/declaration/dfc-apply/details/${tecCiqDecId}` })
  }
  //属地查检 -证书申请 -暂存
  postDeclarationDfcApplTemporaryStorage(data: any) {
    return this.post({ url: `/declaration/dfc-apply/temporaryStorage`, data })
  }
  //属地查检 -证书申请-添加证书-查询缓存
  postDeclarationDfcCacheQuery(data: any) {
    return this.post({ url: `/declaration/dfc/cache/query`, data })
  }
  //属地查检 -证书申请-添加证书-添加缓存
  postDeclarationDfcCacheAdd(data: any) {
    return this.post({ url: `/declaration/dfc/cache/add`, data })
  }
  //属地查检 -证书申请-添加证书删除缓存
  postDeclarationDfcCacheDelete(data: any) {
    return this.post({ url: `/declaration/dfc/cache/delete`, data })
  }
  // 海运舱单列表
  postPyhPageList(data: any) {
    return this.post({ url: `/xiaoguan/declare/pyh/page`, data, baseURL: '' })
  }
  // 海运舱单回执查看
  getQueryReceipt(params: any) {
    return this.get({ url: `/xiaoguan/declare/pyh/queryReceipt`, params, baseURL: '' })
  }
  //证书申请列表
  postDeclarationDfcApply(data: any) {
    return this.post({ url: `/declaration/dfc-apply/page`, data})
  }
  //证书申请列表-详情
  postDeclarationDfcApplyInfo(id: any) {
    return this.post({ url: `/declaration/dfc-apply/info/${id}`})
  }
  //证书申请列表-删除
  postDeclarationDfcApplyDel(params: any) {
    return this.post({ url: `/declaration/dfc-apply/delete/dfcApply`, params})
  }
  //证书申请-新增-通过编号查询电子底账详情
  getDeclarationDfcQueryDeclNo(entDeclNo: any) {
    return this.get({ url: `/declaration/dfc-apply/queryByEntDeclNo/${entDeclNo}`})
  }
  //证书申请-新增-获取系统单号
  getDeclarationDfcGenerateDocNo() {
    return this.get({ url: `/declaration/dfc-apply/generateDocNo`})
  }
  //证书申请列表-同步单一窗口
  postDeclarationDfcApplySyncById(params: any) {
    return this.post({ url: `/declaration/dfc-apply/syncById`, params})
  }
  //证书申请列表-状态列表
  getDeclarationDfcApplyStatus() {
    return this.get({ url: `/declaration/common/dfcApplyStatus`})
  }

  // 电子单据文件上传
  postCiqEdocUpload(data: any) {
    return this.post({ url: `/declaration/ciq-edoc/upload`, data })
  }
  // 电子单据暂存
  postSaveCiqEdoc(data: any) {
    return this.post({ url: `/declaration/ciq-edoc/saveCiqEdoc`, data })
  }
  //删除电子单据
  delCiqEdoc(params: any){
    return this.get({ url: `/declaration/ciq-edoc/deleteById`, params })
  }
  //电子单据列表
  postGetciqEdocList(data:any){
    return this.post({ url: `/declaration/ciq-edoc/page`, data })
  }
  // 电子单据详情(根据电子底账id)
  getDetailCiqEdoc(params: any) {
    return this.get({ url: `/declaration/ciq-edoc/details`, params })
  }
  //电子单据详情
  getDetailCiqEdocById(params: any) {
    return this.get({ url: `/declaration/ciq-edoc/info`, params })
  }
  //获取电子单据海关状态
  getCiqStatus(){
    return this.get({ url: `/declaration/common/ciqStatus`})
  }
  //根据检验检疫编号查询电子底账
  getEntDeclNo(entDeclNo:String){
    return this.get({ url: `/declaration/ciq-edoc/queryByEntDeclNo/${entDeclNo}`})
  }
  //同步至单一窗口
  postSyncSubmit(params: any){
    return this.post({ url: `/declaration/ciq-edoc/syncById`, params })
  }
  // 文件下载/declaration/
  downFile(params: any, responseType: any) {
    return this.get({ url: `/declaration/common/download`, params, responseType })
  }
  //入仓单- 列表
  postServiceOrderWareReceipt(data: any) {
    return this.post({ url: `/service-order/wareReceipt/page`, data })
  }
  //入仓单- 列表 删除
  getServiceOrderWareReceiptDelete(params: any) {
    return this.get({ url: `/service-order/wareReceipt/delete`, params })
  }
  //入仓单- 列表 详情
  getServiceOrderWareReceiptDetail(params: any) {
    return this.get({ url: `/service-order/wareReceipt/detail`, params })
  }
  //入仓单- 列表 新增保存
  postServiceOrderWareReceiptSave(data: any) {
    return this.post({ url: `/service-order/wareReceipt/save`, data })
  }
  //入仓单- 列表 编辑保存
  postServiceOrderWareReceiptUpdate(data: any) {
    return this.post({ url: `/service-order/wareReceipt/update`, data })
  }
  //入仓单- 新增-入仓商品列表
  postServiceOrderInletOrderMember(data: any) {
    return this.post({ url: `/service-order/inlet/order/member/page`, data })
  }

  //企业数据汇总-企业类型枚举
  getBiPlatformType() {
    return this.get({ url: `/bi/organization/platformType` })
  }
  //企业数据汇总-合作企业列表
  getBiPartnerList() {
    return this.get({ url: `/bi/organization/partnerList` })
  }
  //企业数据汇总-关联合作企业
  postBiPartnerList(data: any) {
    return this.post({ url: `/bi/organization/partnerRelation`, data })
  }
  //企业数据汇总-关联合作企业
  getBiPartnerListInfo(organizationCode: any) {
    return this.get({ url: `/bi/organization/partnerList/${organizationCode}` })
  }
  //物流轨迹查询
  getTransportYDWVesselstatus(customsNo: any) {
    return this.get({ url: `/transport/ydw/vesselstatus/${customsNo}` })
  }
  //物流信息查询
  getTransportYDWShippingTracking(declarationNo: any) {
    return this.get({ url: `/transport/ydw/shippingTrackingData/${declarationNo}` })
  }
  //AI助手-欢迎语
  postAiqaInit() {
    return this.post({ url: `/saas/aiqa/init` })
  }
  //AI助手-提取回复要素
  postAiqaExtractAnswer(data: any) {
    return this.post({ url: `/saas/aiqa/extract/answer`, data })
  }
  //AI助手-历史消息
  postAiqaHistory(data: any) {
    return this.post({ url: `/saas/aiqa/history`, data })
  }
  //经营情况表-详情
  getBusinessInfo(id: any) {
    return this.get({ url: `/saas/business/situation/info/${id}` })
  }
  //经营情况表-详情-上传附件
  postSaasUpload(data: any) {
    return this.post({ url: `/saas/common/upload`, data })
  }
  //经营情况表-详情-批量上传附件
  postSaasUploadFiles(params: any) {
    return this.post({ url: `/saas/common/uploadFiles`, params })
  }
  //经营情况表-保存、提交
  postBusinessUpdate(data: any) {
    return this.post({ url: `/saas/business/situation/update`, data })
  }
  //是否进入ai问答
  postAiqaCheck() {
    return this.post({ url: `/saas/aiqa/check` })
  }
  // websocket 需要的参数
  getAiqaCs(type: string) {
    return this.get({ url: `/saas/aiqa/csId` })
  }
  // websocket接收到消息后给后端推送消息
  getAiqaMsgAck(csId: string) {
    return this.get({ url: `/saas/aiqa/msg/ack/${csId}` })
  }
  //经营情况表-列表
  postBusinessList(data: any) {
    return this.post({ url: `/saas/business/situation/page`, data })
  }
  //经营情况表-审核
  postBusinessAudit(data: any) {
    return this.post({ url: `/saas/business/situation/audit`, data })
  }
  //获取资料清单列表
  postGetmaerialsList(data:any){
    return this.post({ url: `/saas/materials/data/page`, data })
  }
  //新增资料清单
  postAddDataList(data:any){
    return this.post({ url: `/saas/materials/data/add`, data })
  }
  //检查重复项
  postCheck(data:any){
    return this.post({ url: `/saas/materials/data/check`, data })
  }
  //编辑资料清单
  postUpdateDataList(data:any){
    return this.post({ url: `/saas/materials/data/edit`, data })
  }
  //资料清单详情
  getDataListDetail(id:String){
    return this.get({url:`/saas//materials/data/info/${id}`})
  }
  //导入资料清单
  postImportDataList(data:any){
    return this.post({ url: `/saas/materials/data/import`, data })
  }
  //导入校验
  postImportCheck(data:any){
    return this.post({ url: `/saas/materials/data/import/check`, data })
  }
  //删除清单
  deleteDataList(id:string){
     return this.delete({url:`/saas/materials/data/remove/${id}`})
  }
  //单个-获取文件流
  getTfileStream(params: any, responseType: any) {
    return this.get({ url: `/saas/common/file/download`, params, responseType })
  }
  //单个-获取压缩包 situationId
  getRAR(params: any, responseType: any) {
    return this.get({ url: `/saas/business/situation/batch/download`, params, responseType })
  }
  //单个-图片预览
  postFilesAddress(data: any) {
    return this.post({ url: `/saas/common/file/address`, data })
  }

  // ------------------------退税助手聊天记录
  //获取问题列表
  postGetAnswerList(data:any){
    return this.post({ url: `/saas/aigc/mh_innner_api/query/all/answer/list`, data })
  }
  //查询用户信息
  getUserDetail(personId:string){
    return this.get({url:`/saas/aigc/mh_innner_api/query/person/detail/${personId}`})
  }
  //查询所有用户名
  getAllUser(){
    return this.get({url:`/saas/aigc/mh_innner_api/query/all/person/list`})
  }
  //查询所有企业名称
  getAllOrganizationName(){
    return this.get({url:`/saas/aigc/mh_innner_api/query/all/organizationName`})
  }
  //导出聊天记录
  postDownloadRecord(data:any,responseType: any){
    return this.post({ url: `/saas/aigc/mh_innner_api/upload/selected/record`, data, responseType})
  }
  //查询聊天记录
  postQueryRecordDetail(id:string){
    return this.post({url:`/saas/aigc/mh_innner_api/query/record/detail/${id}`})
  }

  //发票列表
  postServiceOrderInvoiceImportList(data: any) {
    return this.post({ url: `/service-order/invoice/data/import/page`, data })
  }
  //发票导入检查
  postInvoiceImportCheck(data:any){
    return this.post({ url: `/service-order/invoice/data/import/check`, data })
  }
  //发票列表-导入
  postServiceOrderInvoiceImportExcel(data: any) {
    return this.post({ url: `/service-order/invoice/data/import/excel`, data })
  }
  //发票列表-配单
  getServiceOrderInvoiceImportDeclare(id: any) {
    return this.get({ url: `/service-order/invoice/data/import/declare/${id}` })
  }
  //发票列表-删除
  postServiceOrderInvoiceImportDel(data: any) {
    return this.post({ url: `/service-order/invoice/data/import/del`, data })
  }
  //发票列表-详情
  postServiceOrderInvoiceImporDetail(data: any) {
    return this.post({ url: `/service-order/invoice/data/import/detail/page`, data })
  }
  //发票列表-详情-编辑
  postServiceOrderInvoiceImporDetailEdit(data: any) {
    return this.post({ url: `/service-order/invoice/data/import/detail/update`, data })
  }
  //发票列表-详情-删除
  postServiceOrderInvoiceImporDetailDel(data: any) {
    return this.post({ url: `/service-order/invoice/data/import/detail/del`, data })
  }

  //查询企业关系-列表
  getEnterpriseQueryByPage(params: any) {
    return this.get({ url: `/agreement/enterprise/relation/queryByPage`, params })
  }
  //查询企业合作关系-下拉框
  getEnterpriseTypeList(params: any) {
    return this.get({ url: `/agreement/template/partnership/list`, params })
  }
  //查询企业合作关系-下拉框
  getEnterpriseQueryAll(params: any) {
    return this.get({ url: `/agreement/enterprise/queryAll`, params })
  }
  //查询企业详情
  getEnterpriseQueryDetail(params: any) {
    return this.get({ url: `/agreement/enterprise/queryDetail`, params })
  }
  //选择销售订单(生成报关单)
  postDeclarationOrderSelect(data: any) {
    return this.post({ url: `/service-order/declaration/order/select/salesOrder/for/generate/declaration`, data })
  }
  //根据销售订单生成 报关单
  postDeclarationSalesOrder(data: any) {
    return this.post({ url: `/service-order/declaration/order/generate/declaration/by/salesOrder`, data })
  }
  // 查询销售订单-打单汇总
  postDeclarationTotalStatus(data: any) {
    return this.post({ url: `/service-order/declaration/order/query/salesOrder/generate/total/status`, data })
  }
  // 查询销售订单-打单子单状态
  postDeclarationGenerateStatus(data: any) {
    return this.post({ url: `/service-order/declaration/order/query/salesOrder/generate/status`, data })
  }
   // 查询销售订单-删除打单子单状态
   postDeclarationGenerateDelete(data: any) {
    return this.post({ url: `/service-order/declaration/order/delete/salesOrder/generate/status`, data })
  }

  // 跨赋AI助手-添加商品url
  postClassifyGoods(data: any) {
    return this.post(({ url: `/service-order/goods/classification/smart/classify/goods/`, data }))
  }
  // AI托管接口-列表
  postAssistantList(data: any) {
    return this.post(({ url: `/saas/ai/assistant/page`, data }))
  }
  // AI托管接口-详情
  getAssistantDetail(id: any) {
    return this.get(({ url: `/saas/ai/assistant/info/${id}` }))
  }
  // 消息推送任务-列表
  postSysMsgPushTaskList(data: any) {
    return this.post(({ url: `saas/sys-msg-push-task/page`, data }))
  }
  // 消息推送任务-消息类型
  getSysMsgPushTaskTag() {
    return this.get(({ url: `saas/sys-msg-push-task/tag` }))
  }
  // 消息推送任务-消息状态
  getSysMsgPushTaskStatus() {
    return this.get(({ url: `saas/sys-msg-push-task/status` }))
  }
  // 消息推送任务-新增
  postSysMsgPushTaskAdd(data: any) {
    return this.post(({ url: `saas/sys-msg-push-task/add`, data }))
  }
  // 消息推送任务-编辑
  postSysMsgPushTaskEdit(data: any) {
    return this.post(({ url: `saas/sys-msg-push-task/edit`, data }))
  }
  // 消息推送任务-详情
  getSysMsgPushTaskDetail(id: any) {
    return this.get(({ url: `saas/sys-msg-push-task/info/${id}` }))
  }
  // 消息推送任务-列表-提交
  postSysMsgPushTaskSubmit(id: any) {
    return this.post(({ url: `saas/sys-msg-push-task/submit/${id}` }))
  }
  // 消息推送任务-列表-撤销
  postSysMsgPushTaskCancel(id: any) {
    return this.post(({ url: `saas/sys-msg-push-task/cancel/${id}` }))
  }
  // 消息推送任务-列表-删除
  delSysMsgPushTaskRemove(id: any) {
    return this.delete(({ url: `saas/sys-msg-push-task/remove/${id}` }))
  }
  // 系统消息管理-列表
  postSysMsgList(data: any) {
    return this.post(({ url: `saas/sys-msg/list`, data }))
  }
  // 系统消息管理-详情
  getSysMsgDetail(id: any) {
    return this.get(({ url: `saas/sys-msg/info/${id}`}))
  }
  // 系统消息管理-未读
  getSysMsgUnreadCount() {
    return this.get(({ url: `saas/sys-msg/unReadCount`}))
  }
  // 贷款额度申请&支用(邮惠) - 获取授权状态
  getPsbcSyncStatus() {
    return this.get(({ url: `/service-order/financial/order/psbc/syncStatus`}))
  }
  // 贷款额度申请&支用(邮惠) - 确认签署
  getPsbcUpdateStatus() {
    return this.get(({ url: `/service-order/financial/order/psbc/updateStatus`}))
  }
  //ai-历史记录日期
  postAiqaHistoryDate(data: any) {
    return this.post({ url: `/saas/aigc/mh_innner_api/query/answer/date`, data })
  }
  //判断登陆用户是否是指定账号
  getAssistantCheck() {
    return this.get({ url: `/saas/ai/assistant/check` })
  }
  //AI托管 -退税申报结果
  postAiTaxDeclarationResultData(data: any) {
    return this.post({ url: `/saas/ai/assistant/taxDeclarationResultData`, data })
  }
  //AI托管 -退税申报
  postAiTaxDeclarationData(data: any) {
    return this.post({ url: `/saas/ai/assistant/taxDeclarationData`, data })
  }
  //AI托管 -出口明细
  postAiExportDetailData(data: any) {
    return this.post({ url: `/saas/ai/assistant/exportDetailData`, data })
  }
  //AI托管 -销售订单
  postAiSalesData(data: any) {
    return this.post({ url: `/saas/ai/assistant/salesData`, data })
  }
  //AI托管 -增值税专用发票
  postAiInvoiceData(data: any) {
    return this.post({ url: `/saas/ai/assistant/invoiceData`, data })
  }
  //AI托管 -出口报关单
  postAiExportDeclartionData(data: any) {
    return this.post({ url: `/saas/ai/assistant/exportDeclartionData`, data })
  }
  //AI托管 -报关单草单
  postAiDeclarationData(data: any) {
    return this.post({ url: `/saas/ai/assistant/declarationData`, data })
  }
  //AI托管 -商品列表
  postAiShopData( data: any) {
    return this.post({ url: `/saas/ai/assistant/shopData`, data })
  }
  //AI托管 -疑点识别
  postAiQuestionData( data: any) {
    return this.post({ url: `/saas/ai/assistant/questionData`, data })
  }
  //AI托管 -商品归类列表
  postAiClassifyData( data: any) {
    return this.post({ url: `/saas/ai/assistant/classifyData`, data })
  }
  //AI托管 -详情
  getAiExecInfo(id: any) {
    return this.get({ url: `/saas/ai/assistant/execInfo/${id}` })
  }
  //AI托管 -疑点识别统计
  postAiQuestionDataStatistics(data: any) {
    return this.post({ url: `/saas/ai/assistant/questionDataStatistics`, data })
  }
  //AI托管 -报关单草单 详情
  postAiDeclarationDataInfo(data: any) {
    return this.post({ url: `/saas/ai/assistant/declarationData/info`, data })
  }
  //AI托管 - 进货明细
  postAiPurchaseDetail(data: any) {
    return this.post({ url: `/saas/ai/assistant/purchaseDetailData`, data })
  }
  //AI托管 - 获取AI自动托管状态
  getAiGetOpenStatus() {
    return this.get({ url: `/saas/ai/assistant/getOpenStatus` })
  }
  //AI托管 - 获取最新执行情况
  getAiGetNewstExecInfo(cid: any) {
    return this.get({ url: `/saas/ai/assistant/getNewestExecInfo/${cid}` })
  }
  //AI托管 - 更新AI自动托管状态
  postAiUpdateOpenStatus(data: any) {
    return this.post({ url: `/saas/ai/assistant/updateOpenStatus`, data })
  }
  //AI托管 - 更新左侧数据
  postAiUpdateLeftData(data: any) {
    return this.post({ url: `/saas/ai/assistant/updateLeftData`, data })
  }
  //AI托管 - 更新疑点状态
  postAiUpdateQuestionData(id: any) {
    return this.post({ url: `/saas/ai/assistant/updateQuestionData/${id}` })
  }
  //企业数据汇总-配单方式
  getCommonMatchingOrderWay() {
    return this.get({ url: `/saas/common/matchingOrder/way` })
  }
  //企业数据汇总-配单信息编辑
  postUpdateMatchingOrderWay(data: any) {
    return this.post({ url: `/bi/organization/update/matchingOrderWay`, data })
  }
  // 智能配单-进项发票列表
  importInvoice(data: any) {
    return this.post({ url: `/service-order/import/invoice/query/import/invoice`, data })
  }
  // 智能配单-进项发票导出
  exportInvoice(data:any,responseType: any){
    return this.post({url:'/service-order/import/invoice/export/import/invoice', data,responseType})
  }
  // 智能配单-进项发票详情
  importInvoiceDetail(data: any) {
    return this.post({ url: `/service-order/import/invoice/query/import/invoice/detail`, data })
  }
  // 智能配单-进项发票获取
  updateImportInvoice(data: any) {
    return this.post({ url: `/service-order/import/invoice/mh_innner_api/update/import/invoice`, data })
  }
  //智能配单-出口明细
  postDeclarationExportMember(data: any) {
    return this.post({ url: `/declaration/declaration-export-member/page`, data })
  }
  //智能配单-编辑出口明细
  postUpdateDeclarationExportMember(data:any){
    return this.post({ url: `/declaration/declaration-export-member/update`, data })
  }
  //智能配单-出口明细-同步退税
  postDeclarationExportMemberSend(data: any) {
    return this.post({ url: `/declaration/declaration-export-member/send`, data })
  }
  //智能配单-出口明细-编辑
  postDeclarationUpdate(data: any) {
    return this.post({ url: `/declaration/declaration-export-member/update`, data })
  }
  //智能配单-出口明细-详情
  getDeclarationDetail(id: any) {
    return this.get({ url: `/declaration/declaration-export-member/details/${id}` })
  }
   // 进货明细表-列表 
   getMatePage (data: any) {
    return this.post({ url: `/declaration/declaration-purchase-member/page`, data })
   }
  // 进货明细表-编辑 
  updateMateDetail (data: any) {
    return this.post({ url: `/declaration/declaration-purchase-member/update`, data })
  }
  // 进货明细同步报税
  sendMatePush (data: any) {
    return this.post({ url: `/declaration/declaration-purchase-member/send`, data })
  }
  //ai统计
  postAiCountInfo(data: any) {
    return this.post({ url: `/saas/ai/count/info/`, data })
  }
  //ai托管-左侧渠道
  getAssistantChannel(data: any) {
    return this.get({ url: `/saas/ai/assistant/channel`, data })
  }
  //企业订单产品
  getOrderProductType() {
    return this.get({ url: `/agreement/common/orderProductType` })
  }
  //企业订单服务
  getOrderServerType() {
    return this.get({ url: `/agreement/common/orderServerType` })
  }
  //企业账单状态
  getOrganizationBillStatus() {
    return this.get({ url: `/agreement/common/organizationBillStatus` })
  }
  //企业订单
  postOranizationOrder(data: any) {
    return this.post({ url: `/agreement/organization-order/page`, data })
  }
  //企业账单
  postOranizationBill(data: any) {
    return this.post({ url: `/agreement/organization-bill/page`, data })
  }
  //消息记录列表
  postGroupChatLog(data: any) {
    return this.post({ url: `/saas/groupChatLog/page`, data })
  }
  // 消息记录- 根据消息id获取消息详情
  getGroupChatLogDetail(params: any) {
    return this.get({ url: '/saas/groupChatLog/get', params })
  }
  // 发货计划-列表
  postShipmentPlan(data: any) {
    return this.post({ url: '/service-order/shipmentPlan/page', data })
  }
  // 发货计划-导入
  postShipmentPlanImportExcel(data: any) {
    return this.post({ url: '/service-order/shipmentPlan/importExcel', data })
  }
  // 发货计划-新增
  postShipmentPlanAdd(data: any) {
    return this.post({ url: '/service-order/shipmentPlan/add', data })
  }
  // 发货计划-编辑
  postShipmentPlanUpdate(data: any) {
    return this.post({ url: '/service-order/shipmentPlan/update', data })
  }
  // 发货计划-详情
  getShipmentPlanInfo(id: any) {
    return this.get({ url: `/service-order/shipmentPlan/info/${id}` })
  }
  // 发货计划-删除
  deleteShipmentPlanRemove(ids: any) {
    return this.delete({ url: `/service-order/shipmentPlan/remove/${ids}` })
  }
  // 发货计划-生成报关草单
  postShipmentPlanGenerate(id: any) {
    return this.post({ url: `/service-order/shipmentPlan/generate/${id}` })
  }
  // 开关模块功能
  postIsmodules(isModules: any, organizationId: any) {
    return this.post({ url: `/bi/organization/isModules/${isModules}/${organizationId}` })
  }
  // 切换Ai/企业模式
  getSwitching() {
    return this.get({ url: `/saas/ai/assistant/switching` })
  }
  // 企业关系列表
  postOranizationRel(data: any) {
    return this.post({ url: `/agreement/organizationRel/page`, data })
  }
  // 企业关系map
  getOranizationRelRelation() {
    return this.get({ url: `/agreement/organizationRel/relation` })
  }
  // 推送任务消息-企业列表
  postSysmsgpushtask(data: any) {
    return this.post({ url: `/saas/sys-msg-push-task/organization/page`, data })
  }
  // 推送任务消息-统计数量
  postSysmsgpushtaskSelectedCompanies(data: any) {
    return this.post({ url: `/saas/sys-msg-push-task/selectedCompanies`, data })
  }
}

let instance
export default (() => {
  if (instance) return instance
  instance = new Request()
  return instance
})()
